import React from "react";
import '../index.css';
import '../componentCSS/animatedContactImage.css';

function ContactIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="freepik_stories-get-in-touch"
      className="animated"
      version="1.1"
      viewBox="0 0 500 500"
    >
      <g
        id="freepik--Floor--inject-66"
        className="animable"
        style={{
          WebkitTransformOrigin: 251.72,
          MsTransformOrigin: 251.72,
          transformOrigin: 251.72,
        }}
      >
        <ellipse
          id="freepik--floor--inject-66"
          cx="251.72"
          cy="350.29"
          fill="#F5F5F5"
          rx="235.28"
          ry="124.1"
          style={{
            WebkitTransformOrigin: 251.72,
            MsTransformOrigin: 251.72,
            transformOrigin: 251.72,
          }}
          className="animable"
        ></ellipse>
      </g>
      <g
        id="freepik--Shadows--inject-66"
        className="animable"
        style={{
          WebkitTransformOrigin: 263.702,
          MsTransformOrigin: 263.702,
          transformOrigin: 263.702,
        }}
      >
        <path
          id="freepik--Shadow--inject-66"
          d="M400.74 309.58c-16.3 9.41-16.3 24.66 0 34.07s42.71 9.41 59 0 16.29-24.66 0-34.07-42.74-9.41-59 0z"
          style={{
            WebkitTransformOrigin: 430.236,
            MsTransformOrigin: 430.236,
            transformOrigin: 430.236,
          }}
          fill="#E6E6E6"
          className="animable"
        ></path>
        <ellipse
          id="freepik--shadow--inject-66"
          cx="366.08"
          cy="381.84"
          fill="#E0E0E0"
          rx="64.58"
          ry="37.28"
          style={{
            WebkitTransformOrigin: 366.08,
            MsTransformOrigin: 366.08,
            transformOrigin: 366.08,
          }}
          className="animable"
        ></ellipse>
        <path
          id="freepik--shadow--inject-66"
          d="M57 411.58l6.6 3.81a8.35 8.35 0 007.54 0l145.52-84c2.08-1.2 2.08-3.15 0-4.35l-6.61-3.81a8.26 8.26 0 00-7.53 0L57 407.23c-2.07 1.2-2.07 3.15 0 4.35z"
          style={{
            WebkitTransformOrigin: 136.834,
            MsTransformOrigin: 136.834,
            transformOrigin: 136.834,
          }}
          fill="#E0E0E0"
          className="animable"
        ></path>
        <path
          id="freepik--shadow--inject-66"
          d="M94 419.63l6.6 3.81a8.35 8.35 0 007.54 0L232.33 352c2.08-1.2 2.08-3.15 0-4.35l-6.6-3.82a8.35 8.35 0 00-7.54 0L94 415.28c-2.06 1.2-2.06 3.15 0 4.35z"
          style={{
            WebkitTransformOrigin: 163.173,
            MsTransformOrigin: 163.173,
            transformOrigin: 163.173,
          }}
          fill="#E0E0E0"
          className="animable"
        ></path>
      </g>
      <g
        id="freepik--Pictures--inject-66"
        className="animable"
        style={{
          WebkitTransformOrigin: 435.715,
          MsTransformOrigin: 435.715,
          transformOrigin: 435.715,
        }}
      >
        <g
          id="freepik--Picture--inject-66"
          className="animable"
          style={{
            WebkitTransformOrigin: 435.715,
            MsTransformOrigin: 435.715,
            transformOrigin: 435.715,
          }}
        >
          <g
            id="freepik--Frame--inject-66"
            className="animable"
            style={{
              WebkitTransformOrigin: 435.715,
              MsTransformOrigin: 435.715,
              transformOrigin: 435.715,
            }}
          >
            <path
              style={{
                WebkitTransformOrigin: 435.705,
                MsTransformOrigin: 435.705,
                transformOrigin: 435.705,
              }}
              id="el0xbbeascneu"
              fill="#FAFAFA"
              d="M454.46 111.28L452.71 112.32 416.95 91.68 418.69 90.64 454.46 111.28z"
              className="animable"
            ></path>
            <path
              style={{
                WebkitTransformOrigin: 435.7,
                MsTransformOrigin: 435.7,
                transformOrigin: 435.7,
              }}
              id="el6604agfp5s"
              fill="#FFF"
              d="M418.69 90.64L452.71 110.27 452.71 74.65 418.69 55.02 418.69 90.64z"
              className="animable"
            ></path>
            <path
              d="M413.66 93.57L456 118V72.75l-42.34-24.44zM417 54l35.76 20.65v37.67L417 91.68z"
              style={{
                WebkitTransformOrigin: 434.83,
                MsTransformOrigin: 434.83,
                transformOrigin: 434.83,
              }}
              id="elqcgchze91h"
              fill="#F0F0F0"
              className="animable"
            ></path>
            <path
              style={{
                WebkitTransformOrigin: 417.82,
                MsTransformOrigin: 417.82,
                transformOrigin: 417.82,
              }}
              id="el9pf3q1dap7h"
              fill="#E0E0E0"
              d="M416.95 91.68L418.69 90.64 418.69 55.02 416.95 54 416.95 91.68z"
              className="animable"
            ></path>
            <path
              style={{
                WebkitTransformOrigin: 435.715,
                MsTransformOrigin: 435.715,
                transformOrigin: 435.715,
              }}
              id="elinbxstd67ft"
              fill="#FAFAFA"
              d="M413.66 48.3L415.43 47.29 457.77 71.74 456 72.75 413.66 48.3z"
              className="animable"
            ></path>
            <path
              style={{
                WebkitTransformOrigin: 456.885,
                MsTransformOrigin: 456.885,
                transformOrigin: 456.885,
              }}
              id="elgkqf7c3yahc"
              fill="#E0E0E0"
              d="M457.77 71.74L456 72.75 456 118.02 457.77 117.01 457.77 71.74z"
              className="animable"
            ></path>
          </g>
          <g
            id="freepik--Land--inject-66"
            className="animable"
            style={{
              WebkitTransformOrigin: 435.705,
              MsTransformOrigin: 435.705,
              transformOrigin: 435.705,
            }}
          >
            <path
              style={{
                WebkitTransformOrigin: 435.705,
                MsTransformOrigin: 435.705,
                transformOrigin: 435.705,
              }}
              id="elovixgsyutl8"
              fill="#F0F0F0"
              d="M420.02 89.57L451.39 107.68 451.39 98.63 443.54 80.52 438.66 85.05 440.42 92.64 429.59 69.47 420.02 80.52 420.02 89.57z"
              className="animable"
            ></path>
            <path
              d="M439 71.78a5.07 5.07 0 012.32 4c0 1.48-1 2.08-2.32 1.34a5.12 5.12 0 01-2.31-4c-.05-1.48.98-2.12 2.31-1.34z"
              style={{
                WebkitTransformOrigin: 439.004,
                MsTransformOrigin: 439.004,
                transformOrigin: 439.004,
              }}
              id="elbgfj6firoa7"
              fill="#F0F0F0"
              className="animable"
            ></path>
          </g>
        </g>
        <g
          id="freepik--picture--inject-66"
          className="animable"
          style={{
            WebkitTransformOrigin: 435.715,
            MsTransformOrigin: 435.715,
            transformOrigin: 435.715,
          }}
        >
          <g
            id="freepik--frame--inject-66"
            className="animable"
            style={{
              WebkitTransformOrigin: 435.715,
              MsTransformOrigin: 435.715,
              transformOrigin: 435.715,
            }}
          >
            <path
              style={{
                WebkitTransformOrigin: 435.705,
                MsTransformOrigin: 435.705,
                transformOrigin: 435.705,
              }}
              id="els039durjsmf"
              fill="#FAFAFA"
              d="M454.46 168.16L452.71 169.2 416.95 148.55 418.69 147.51 454.46 168.16z"
              className="animable"
            ></path>
            <path
              style={{
                WebkitTransformOrigin: 435.7,
                MsTransformOrigin: 435.7,
                transformOrigin: 435.7,
              }}
              id="elj06yinujcwj"
              fill="#FFF"
              d="M418.69 147.51L452.71 167.15 452.71 131.52 418.69 111.9 418.69 147.51z"
              className="animable"
            ></path>
            <path
              d="M413.66 150.45L456 174.89v-45.27l-42.34-24.44zm3.34-39.58l35.76 20.65v37.68L417 148.55z"
              style={{
                WebkitTransformOrigin: 434.83,
                MsTransformOrigin: 434.83,
                transformOrigin: 434.83,
              }}
              id="elxpwjqh60w5"
              fill="#F0F0F0"
              className="animable"
            ></path>
            <path
              style={{
                WebkitTransformOrigin: 417.82,
                MsTransformOrigin: 417.82,
                transformOrigin: 417.82,
              }}
              id="el85siibm5tpd"
              fill="#E0E0E0"
              d="M416.95 148.55L418.69 147.51 418.69 111.9 416.95 110.87 416.95 148.55z"
              className="animable"
            ></path>
            <path
              style={{
                WebkitTransformOrigin: 435.715,
                MsTransformOrigin: 435.715,
                transformOrigin: 435.715,
              }}
              id="eln3au846rcwf"
              fill="#FAFAFA"
              d="M413.66 105.18L415.43 104.16 457.77 128.61 456 129.62 413.66 105.18z"
              className="animable"
            ></path>
            <path
              style={{
                WebkitTransformOrigin: 456.885,
                MsTransformOrigin: 456.885,
                transformOrigin: 456.885,
              }}
              id="elax3vs5rz2a"
              fill="#E0E0E0"
              d="M457.77 128.61L456 129.62 456 174.89 457.77 173.88 457.77 128.61z"
              className="animable"
            ></path>
          </g>
          <g
            id="freepik--land--inject-66"
            className="animable"
            style={{
              WebkitTransformOrigin: 435.705,
              MsTransformOrigin: 435.705,
              transformOrigin: 435.705,
            }}
          >
            <path
              style={{
                WebkitTransformOrigin: 435.705,
                MsTransformOrigin: 435.705,
                transformOrigin: 435.705,
              }}
              id="el9sbibvu29g"
              fill="#F0F0F0"
              d="M420.02 146.44L451.39 164.55 451.39 155.5 443.54 137.39 438.66 141.92 440.42 149.51 429.59 126.35 420.02 137.39 420.02 146.44z"
              className="animable"
            ></path>
            <path
              d="M439 128.65a5.1 5.1 0 012.32 4c0 1.48-1 2.08-2.32 1.34a5.11 5.11 0 01-2.31-4c-.05-1.48.98-2.08 2.31-1.34z"
              style={{
                WebkitTransformOrigin: 439.004,
                MsTransformOrigin: 439.004,
                transformOrigin: 439.004,
              }}
              id="elb3kg45baerw"
              fill="#F0F0F0"
              className="animable"
            ></path>
          </g>
        </g>
      </g>
      <g
        id="freepik--Plants--inject-66"
        className="animable animator-hidden"
        style={{
          WebkitTransformOrigin: 48.4203,
          MsTransformOrigin: 48.4203,
          transformOrigin: 48.4203,
        }}
      >
        <g
          id="freepik--plants--inject-66"
          className="animable"
          style={{
            WebkitTransformOrigin: 48.4203,
            MsTransformOrigin: 48.4203,
            transformOrigin: 48.4203,
          }}
        >
          <path
            d="M66.6 400.74c2.47-13.73 3.63-28.95-1-50.35-3.88-18-13.64-33.45-24.88-35.49-4.56-.83-9.24 1.82-10.4 4.6-3.18 7.65 2.66 14.62 5.38 18.1 2 2.6 20.87 21.08 22.45 49.2l.94 16.82c.14.87.9 1.31 1.5.87z"
            style={{
              WebkitTransformOrigin: 49.0799,
              MsTransformOrigin: 49.0799,
              transformOrigin: 49.0799,
            }}
            id="elyjmams1dst"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M66.6 400.74c2.47-13.73 3.63-28.95-1-50.35-3.88-18-13.64-33.45-24.88-35.49-4.56-.83-9.24 1.82-10.4 4.6-3.18 7.65 2.66 14.62 5.38 18.1 2 2.6 20.87 21.08 22.45 49.2l.94 16.82c.14.87.9 1.31 1.5.87z"
            style={{
              WebkitTransformOrigin: 49.0799,
              MsTransformOrigin: 49.0799,
              transformOrigin: 49.0799,
            }}
            id="el92koyknpah"
            fill="#FFF"
            className="animable"
            opacity="0.3"
          ></path>
          <path
            d="M63.51 394.42a.66.66 0 01-.35-.64c.67-35.82-9.84-58.21-25-70.87A.76.76 0 0138 322a.43.43 0 01.69-.19c15.37 12.81 26.16 35.7 25.47 72a.58.58 0 01-.51.64z"
            style={{
              WebkitTransformOrigin: 51.0528,
              MsTransformOrigin: 51.0528,
              transformOrigin: 51.0528,
            }}
            id="ell3r7dtn7tw"
            fill="#FFF"
            className="animable"
          ></path>
          <path
            d="M60.59 404.49c-1.68 1.19-2.6-1.26-3.44-4.07-2.69-9.06-5.65-13.84-10.7-20.2-6.23-7.83-17-15.06-18.22-21.54-1.08-5.88 3.65-10.41 12.07-7.27 10.11 3.78 23.77 16 23.31 51.19z"
            style={{
              WebkitTransformOrigin: 45.8495,
              MsTransformOrigin: 45.8495,
              transformOrigin: 45.8495,
            }}
            id="elshb6qx5btj8"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M61.31 400a.64.64 0 01-.4-.51c-4.77-27.15-19.84-40.62-26.81-43.29a.72.72 0 01-.37-.81c.07-.34.33-.54.61-.43 7.72 2.94 22.68 16.58 27.56 44.3a.63.63 0 01-.38.75.3.3 0 01-.21-.01z"
            style={{
              WebkitTransformOrigin: 47.8155,
              MsTransformOrigin: 47.8155,
              transformOrigin: 47.8155,
            }}
            id="elmb5djd4ao8t"
            fill="#FFF"
            className="animable"
          ></path>
        </g>
      </g>
      <g
        id="freepik--Table--inject-66"
        className="animable"
        style={{
          WebkitTransformOrigin: 430.072,
          MsTransformOrigin: 430.072,
          transformOrigin: 430.072,
        }}
      >
        <g
          id="freepik--table--inject-66"
          className="animable"
          style={{
            WebkitTransformOrigin: 430.072,
            MsTransformOrigin: 430.072,
            transformOrigin: 430.072,
          }}
        >
          <g
            id="freepik--table--inject-66"
            className="animable"
            style={{
              WebkitTransformOrigin: 430.072,
              MsTransformOrigin: 430.072,
              transformOrigin: 430.072,
            }}
          >
            <path
              d="M400.45 280.62a1.07 1.07 0 01.63-.87 3.35 3.35 0 013 0 1.07 1.07 0 01.62.87l-7.6 44.87a.76.76 0 01-.44.6 2.35 2.35 0 01-2.13 0 .74.74 0 01-.44-.6z"
              style={{
                WebkitTransformOrigin: 399.395,
                MsTransformOrigin: 399.395,
                transformOrigin: 399.395,
              }}
              id="el91b2brodqbp"
              fill="#455A64"
              className="animable"
            ></path>
            <path
              d="M459.06 280.62a1.07 1.07 0 00-.63-.87 3.33 3.33 0 00-3 0 1.07 1.07 0 00-.63.87l7.6 44.87a.76.76 0 00.44.6 2.37 2.37 0 002.14 0 .78.78 0 00.44-.6z"
              style={{
                WebkitTransformOrigin: 460.11,
                MsTransformOrigin: 460.11,
                transformOrigin: 460.11,
              }}
              id="elijr85foi33j"
              fill="#455A64"
              className="animable"
            ></path>
            <path
              d="M432.15 284a1.07 1.07 0 00-.63-.87 3.33 3.33 0 00-3 0 1.07 1.07 0 00-.63.87l.63 53.38a.76.76 0 00.44.6 2.35 2.35 0 002.13 0 .74.74 0 00.44-.6z"
              style={{
                WebkitTransformOrigin: 430.02,
                MsTransformOrigin: 430.02,
                transformOrigin: 430.02,
              }}
              id="el0igsqr67zxt6"
              fill="#455A64"
              className="animable"
            ></path>
            <path
              d="M468.27 265.84c0-5.65-3.7-11.3-11.17-15.61-14.93-8.63-39.16-8.63-54.09 0-7.47 4.31-11.18 10-11.17 15.61v3c.09 5.58 3.83 11.14 11.21 15.4 14.94 8.62 39.16 8.62 54.09 0 7.38-4.26 11.12-9.82 11.21-15.4z"
              style={{
                WebkitTransformOrigin: 430.095,
                MsTransformOrigin: 430.095,
                transformOrigin: 430.095,
              }}
              id="el661nwlbxkr"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M468.27 265.84c0-5.65-3.7-11.3-11.17-15.61-14.93-8.63-39.16-8.63-54.09 0-7.47 4.31-11.18 10-11.17 15.61v3c.09 5.58 3.83 11.14 11.21 15.4 14.94 8.62 39.16 8.62 54.09 0 7.38-4.26 11.12-9.82 11.21-15.4z"
              style={{
                WebkitTransformOrigin: 430.095,
                MsTransformOrigin: 430.095,
                transformOrigin: 430.095,
              }}
              id="elpwgx4p9qx8"
              fill="#FFF"
              className="animable"
              opacity="0.4"
            ></path>
            <path
              d="M403 250.23c-14.94 8.62-14.94 22.61 0 31.23s39.16 8.63 54.09 0 14.94-22.61 0-31.23-39.19-8.63-54.09 0z"
              style={{
                WebkitTransformOrigin: 430.043,
                MsTransformOrigin: 430.043,
                transformOrigin: 430.043,
              }}
              id="elpmehqc69ar"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M403 250.23c-14.94 8.62-14.94 22.61 0 31.23s39.16 8.63 54.09 0 14.94-22.61 0-31.23-39.19-8.63-54.09 0z"
              style={{
                WebkitTransformOrigin: 430.043,
                MsTransformOrigin: 430.043,
                transformOrigin: 430.043,
              }}
              id="elmic1falgb3e"
              fill="#FFF"
              className="animable"
              opacity="0.6"
            ></path>
          </g>
          <g
            id="freepik--Pot--inject-66"
            className="animable"
            style={{
              WebkitTransformOrigin: 429.924,
              MsTransformOrigin: 429.924,
              transformOrigin: 429.924,
            }}
          >
            <g
              style={{
                WebkitTransformOrigin: 429.773,
                MsTransformOrigin: 429.773,
                transformOrigin: 429.773,
              }}
              id="el5ut7srd7rve"
              className="animable"
              opacity="0.05"
            >
              <path
                id="elgf36lwyk1xa"
                d="M438.4 258.55c4.76 2.75 4.76 7.21 0 10s-12.49 2.75-17.25 0-4.77-7.21 0-10 12.48-2.75 17.25 0z"
                className="animable"
                style={{
                  WebkitTransformOrigin: 429.773,
                  MsTransformOrigin: 429.773,
                  transformOrigin: 429.773,
                }}
              ></path>
            </g>
            <path
              d="M422.18 264.14c-4.15-4.23-6.59-14.81-2.54-18.16h20.59c4 3.35 1.61 13.92-2.53 18.16l-.12.11a.93.93 0 01-.14.14l-.37.34-.1.08-.32.23a4.41 4.41 0 01-.53.35 13.68 13.68 0 01-12.37 0c-.18-.11-.36-.22-.54-.35l-.29-.22-.12-.1a3.73 3.73 0 01-.36-.32l-.17-.16z"
              style={{
                WebkitTransformOrigin: 429.924,
                MsTransformOrigin: 429.924,
                transformOrigin: 429.924,
              }}
              id="el0xcc7k03an4"
              fill="#EBEBEB"
              className="animable"
            ></path>
            <path
              d="M438.44 244.62c4.7 2.72 4.7 7.12 0 9.83s-12.31 2.71-17 0-4.7-7.11 0-9.83 12.31-2.71 17 0z"
              style={{
                WebkitTransformOrigin: 429.942,
                MsTransformOrigin: 429.942,
                transformOrigin: 429.942,
              }}
              id="elgopfo943ubk"
              fill="#FAFAFA"
              className="animable"
            ></path>
            <path
              d="M435.11 246.55c2.86 1.65 2.86 4.32 0 6a11.44 11.44 0 01-10.35 0c-2.86-1.65-2.86-4.32 0-6a11.44 11.44 0 0110.35 0z"
              style={{
                WebkitTransformOrigin: 429.935,
                MsTransformOrigin: 429.935,
                transformOrigin: 429.935,
              }}
              id="elrl6opi61br"
              fill="#EBEBEB"
              className="animable"
            ></path>
            <path
              d="M424.76 249.38a11.44 11.44 0 0110.35 0 4.7 4.7 0 011.71 1.57 4.54 4.54 0 01-1.71 1.57 11.44 11.44 0 01-10.35 0 4.54 4.54 0 01-1.71-1.57 4.7 4.7 0 011.71-1.57z"
              style={{
                WebkitTransformOrigin: 429.935,
                MsTransformOrigin: 429.935,
                transformOrigin: 429.935,
              }}
              id="el44pnpqq1ca4"
              fill="#E0E0E0"
              className="animable"
            ></path>
            <path
              d="M434.48 251a23.48 23.48 0 003.75-5c1.73-3.06 2-7.16 1.15-7.66s-4.53 3.58-4.53 3.58a22.45 22.45 0 00.38-5.22c-.15-2.73-.82-5.2-1.6-5.7s-2.52 2.94-3.27 5.43-1.19 4.53-1.19 4.53a39.33 39.33 0 00-1.35-5.73c-.9-2.58-1.73-3.17-2.37-2.91s-1.06 1.46-1.24 4.9a34.61 34.61 0 00.15 4.93s-1.28-1.41-2.71-2.78-2.23-1.71-2.68-1.42-.57 2.62 1.86 7a24.2 24.2 0 004.57 6s3.35 2.17 9.08.05z"
              style={{
                WebkitTransformOrigin: 429.279,
                MsTransformOrigin: 429.279,
                transformOrigin: 429.279,
              }}
              id="elb4i5jnifgu"
              fill="#8AC832"
              className="animable"
            ></path>
          </g>
        </g>
      </g>
      <g
        id="freepik--Device--inject-66"
        className="animable"
        style={{
          WebkitTransformOrigin: 129.42,
          MsTransformOrigin: 129.42,
          transformOrigin: 129.42,
        }}
      >
        <g
          id="freepik--Mobile--inject-66"
          className="animable"
          style={{
            WebkitTransformOrigin: 129.42,
            MsTransformOrigin: 129.42,
            transformOrigin: 129.42,
          }}
        >
          <path
            d="M184.56 31.76l-122.2 70.56a12.32 12.32 0 00-6.15 10.2v284.12c0 4.18 2.58 9.06 5.76 10.9s8.7 1.63 12.32-.46l121.78-70.31a14.55 14.55 0 006.55-11.35V42.19c0-4.18-2.58-9-5.76-10.89s-8.69-1.63-12.3.46z"
            style={{
              WebkitTransformOrigin: 129.415,
              MsTransformOrigin: 129.415,
              transformOrigin: 129.415,
            }}
            id="els9ifg30n07f"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M184.56 31.76l-122.2 70.56a12.32 12.32 0 00-6.15 10.2v284.12c0 4.18 2.58 9.06 5.76 10.9s8.7 1.63 12.32-.46l121.78-70.31a14.55 14.55 0 006.55-11.35V42.19c0-4.18-2.58-9-5.76-10.89s-8.69-1.63-12.3.46z"
            style={{
              WebkitTransformOrigin: 129.415,
              MsTransformOrigin: 129.415,
              transformOrigin: 129.415,
            }}
            id="elzf8f54ogyk"
            className="animable"
            opacity="0.05"
          ></path>
          <path
            d="M72.72 407.83c-3.5 1.36-8 1.29-10.74-.29-3.18-1.84-5.76-6.72-5.76-10.9V112.52a11.76 11.76 0 011.66-5.62l10.57 6a12.76 12.76 0 00-3 7.63V402c-.06 5 3.12 7.37 7.27 5.83z"
            style={{
              WebkitTransformOrigin: 64.47,
              MsTransformOrigin: 64.47,
              transformOrigin: 64.47,
            }}
            id="el6zk1wriyt5j"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M72.72 407.83c-3.5 1.36-8 1.29-10.74-.29-3.18-1.84-5.76-6.72-5.76-10.9V112.52a11.76 11.76 0 011.66-5.62l10.57 6a12.76 12.76 0 00-3 7.63V402c-.06 5 3.12 7.37 7.27 5.83z"
            style={{
              WebkitTransformOrigin: 64.47,
              MsTransformOrigin: 64.47,
              transformOrigin: 64.47,
            }}
            id="elmbqq4aehvhh"
            className="animable"
            opacity="0.3"
          ></path>
          <path
            d="M71.17 110.53a12.81 12.81 0 00-5.78 10V402c0 5.64 4 8 8.89 5.13l121.8-70.32a14.55 14.55 0 006.55-11.35V42.19c0-4.16-2.95-5.86-6.55-3.78z"
            style={{
              WebkitTransformOrigin: 134.01,
              MsTransformOrigin: 134.01,
              transformOrigin: 134.01,
            }}
            id="elymnncd5dz5h"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M71.17 110.53a12.81 12.81 0 00-5.78 10V402c0 5.64 4 8 8.89 5.13l121.8-70.32a14.55 14.55 0 006.55-11.35V42.19c0-4.16-2.95-5.86-6.55-3.78z"
            style={{
              WebkitTransformOrigin: 134.01,
              MsTransformOrigin: 134.01,
              transformOrigin: 134.01,
            }}
            id="elw9ruiarkpy"
            className="animable"
            opacity="0.15"
          ></path>
          <path
            d="M75.66 127.46a13.77 13.77 0 00-6.23 10.79v252.62c0 4 2.79 5.58 6.23 3.59L190.72 328a13.82 13.82 0 006.22-10.79V64.62c0-4-2.8-5.57-6.23-3.59z"
            style={{
              WebkitTransformOrigin: 133.185,
              MsTransformOrigin: 133.185,
              transformOrigin: 133.185,
            }}
            id="eljdh7ueylt59"
            fill="#263238"
            className="animable"
          ></path>
          <path
            d="M187.42 310.33V62.93L75.66 127.46a13.78 13.78 0 00-6.23 10.79v247.4l111.76-64.54a13.79 13.79 0 006.23-10.78z"
            style={{
              WebkitTransformOrigin: 128.425,
              MsTransformOrigin: 128.425,
              transformOrigin: 128.425,
            }}
            id="elhxp1uhor1yp"
            fill="#37474F"
            className="animable"
          ></path>
          <path
            d="M123.71 88.18l19-10.94c1.13-.65 2.05-.19 2.05 1a4.38 4.38 0 01-2.05 3.4l-19 11c-1.13.65-2 .19-2-1a4.4 4.4 0 012-3.46z"
            style={{
              WebkitTransformOrigin: 133.235,
              MsTransformOrigin: 133.235,
              transformOrigin: 133.235,
            }}
            id="elul601l03g2f"
            fill="#263238"
            className="animable"
          ></path>
          <path
            d="M156.23 69.38c1.06-.62 1.92-.12 1.92 1.11a4.24 4.24 0 01-1.92 3.32c-1.06.61-1.92.12-1.92-1.11a4.24 4.24 0 011.92-3.32z"
            style={{
              WebkitTransformOrigin: 156.23,
              MsTransformOrigin: 156.23,
              transformOrigin: 156.23,
            }}
            id="elhlzkw1gf5qb"
            fill="#263238"
            className="animable"
          ></path>
          <path
            d="M163.92 64.94c1.06-.61 1.92-.11 1.92 1.11a4.24 4.24 0 01-1.92 3.33c-1.06.61-1.92.12-1.92-1.11a4.27 4.27 0 011.92-3.33z"
            style={{
              WebkitTransformOrigin: 163.92,
              MsTransformOrigin: 163.92,
              transformOrigin: 163.92,
            }}
            id="el6x6v5z2boo4"
            fill="#263238"
            className="animable"
          ></path>
          <path
            d="M102.45 100.43c1.06-.61 1.92-.12 1.92 1.11a4.27 4.27 0 01-1.92 3.33c-1.06.61-1.92.11-1.92-1.11a4.24 4.24 0 011.92-3.33z"
            style={{
              WebkitTransformOrigin: 102.45,
              MsTransformOrigin: 102.45,
              transformOrigin: 102.45,
            }}
            id="elwnarwa0lba"
            fill="#263238"
            className="animable"
          ></path>
          <path
            d="M110.14 96c1.06-.62 1.92-.12 1.92 1.11a4.24 4.24 0 01-1.92 3.32c-1.06.62-1.92.12-1.92-1.11a4.24 4.24 0 011.92-3.32z"
            style={{
              WebkitTransformOrigin: 110.14,
              MsTransformOrigin: 110.14,
              transformOrigin: 110.14,
            }}
            id="el1vxjv39eoiw"
            fill="#263238"
            className="animable"
          ></path>
        </g>
      </g>
      <g
        id="freepik--Icons--inject-66"
        className="animable"
        style={{
          WebkitTransformOrigin: 292.175,
          MsTransformOrigin: 292.175,
          transformOrigin: 292.175,
        }}
      >
        <g
          id="freepik--Mail--inject-66"
          className="animable"
          style={{
            WebkitTransformOrigin: 337.27,
            MsTransformOrigin: 337.27,
            transformOrigin: 337.27,
          }}
        >
          <g
            id="freepik--Box--inject-66"
            className="animable"
            style={{
              WebkitTransformOrigin: 337.27,
              MsTransformOrigin: 337.27,
              transformOrigin: 337.27,
            }}
          >
            <path
              d="M355.88 190.26a4.78 4.78 0 00-2.16-3.73l-1.75-1a4.79 4.79 0 00-4.3 0l-26.86 15.54a4.73 4.73 0 00-2.15 3.72v29.56a4.76 4.76 0 002.15 3.73l1.75 1a4.79 4.79 0 004.3 0l26.86-15.54a4.74 4.74 0 002.16-3.73z"
              style={{
                WebkitTransformOrigin: 337.27,
                MsTransformOrigin: 337.27,
                transformOrigin: 337.27,
              }}
              id="elbwj56qypw1"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M318.66 234.34a4.76 4.76 0 002.15 3.73l1.75 1a4.8 4.8 0 003.93.17c-1 .38-1.78-.19-1.78-1.41v-29.55a4.36 4.36 0 01.63-2.12l-6-3.5a4.43 4.43 0 00-.63 2.12z"
              style={{
                WebkitTransformOrigin: 322.575,
                MsTransformOrigin: 322.575,
                transformOrigin: 322.575,
              }}
              id="el5i7qmvse40n"
              className="animable"
              opacity="0.2"
            ></path>
            <path
              d="M355.8 189.65c-.25-.92-1.08-1.21-2.07-.63l-26.87 15.54a4.25 4.25 0 00-1.51 1.6l-6.06-3.49a4.38 4.38 0 011.52-1.61l26.86-15.54a4.79 4.79 0 014.3 0l1.76 1a4.72 4.72 0 012.07 3.13z"
              style={{
                WebkitTransformOrigin: 337.545,
                MsTransformOrigin: 337.545,
                transformOrigin: 337.545,
              }}
              id="elczu1hfr983n"
              fill="#FFF"
              className="animable"
              opacity="0.3"
            ></path>
          </g>
          <path
            id="freepik--mail--inject-66"
            d="M349.24 200.34a.58.58 0 00-.57 0l-17.56 10.14a.56.56 0 00-.28.49v16.66a.58.58 0 00.28.49.6.6 0 00.28.08.6.6 0 00.29-.08L349.24 218a.58.58 0 00.28-.49v-16.68a.58.58 0 00-.28-.49zM340 215.17l-7.46-4.17 14.85-8.57zm-2.58-.16L332 225.33v-13.39zm1 .56l1.52.87a.58.58 0 00.28.07.55.55 0 00.49-.28l1.72-2.95 5.54 4.15-15.11 8.72zm4.58-3.28l5.43-9.35v13.42z"
            style={{
              WebkitTransformOrigin: 340.175,
              MsTransformOrigin: 340.175,
              transformOrigin: 340.175,
            }}
            fill="#FAFAFA"
            className="animable"
          ></path>
        </g>
        <g
          id="freepik--Chat--inject-66"
          className="animable"
          style={{
            WebkitTransformOrigin: 292.215,
            MsTransformOrigin: 292.215,
            transformOrigin: 292.215,
          }}
        >
          <g
            id="freepik--box--inject-66"
            className="animable"
            style={{
              WebkitTransformOrigin: 292.215,
              MsTransformOrigin: 292.215,
              transformOrigin: 292.215,
            }}
          >
            <path
              d="M310.82 216.24a4.73 4.73 0 00-2.15-3.72l-1.75-1a4.72 4.72 0 00-4.3 0L275.76 227a4.76 4.76 0 00-2.15 3.73v29.55a4.75 4.75 0 002.15 3.73l1.75 1a4.72 4.72 0 004.3 0l26.86-15.54a4.73 4.73 0 002.15-3.72z"
              style={{
                WebkitTransformOrigin: 292.215,
                MsTransformOrigin: 292.215,
                transformOrigin: 292.215,
              }}
              id="elc0f8irpjji"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M273.61 260.32a4.75 4.75 0 002.15 3.73l1.75 1a4.76 4.76 0 003.93.17c-1 .39-1.78-.18-1.78-1.41v-29.55a4.43 4.43 0 01.63-2.12l-6.05-3.49a4.36 4.36 0 00-.63 2.12z"
              style={{
                WebkitTransformOrigin: 277.525,
                MsTransformOrigin: 277.525,
                transformOrigin: 277.525,
              }}
              id="elif8zzyxe87o"
              className="animable"
              opacity="0.2"
            ></path>
            <path
              d="M310.75 215.63c-.25-.91-1.08-1.2-2.07-.63l-26.87 15.54a4.3 4.3 0 00-1.52 1.61l-6.05-3.5a4.35 4.35 0 011.52-1.6l26.85-15.54a4.75 4.75 0 014.31 0l1.76 1a4.75 4.75 0 012.07 3.12z"
              style={{
                WebkitTransformOrigin: 292.495,
                MsTransformOrigin: 292.495,
                transformOrigin: 292.495,
              }}
              id="eli6dmlayytap"
              fill="#FFF"
              className="animable"
              opacity="0.3"
            ></path>
          </g>
          <path
            id="freepik--chat--inject-66"
            d="M304.22 232.51l-8.5 4.91a4.88 4.88 0 00-1.85 3.91v6.15c0 1.57.83 2.37 1.85 1.78l4.51-2.61 3.14 3.3a.27.27 0 00.35 0 .79.79 0 00.23-.22 1.43 1.43 0 00.25-.95l-.63-4.09.65-.37a4.88 4.88 0 001.85-3.91v-6.15c0-1.54-.83-2.34-1.85-1.75zm.89 8.79a2.33 2.33 0 01-.89 1.87l-1.24.72a1 1 0 00-.38.49 1.38 1.38 0 00-.09.68l.38 2.23-2.11-1.9a.26.26 0 00-.35 0l-4.71 2.72c-.49.29-.89-.1-.89-.85v-6.46a2.33 2.33 0 01.89-1.87l8.5-4.91c.49-.28.89.1.89.85zm-12.31 1.88l-.16.09a.86.86 0 00-.28.31l-4.11 7 .24-4a.84.84 0 00-.07-.61.27.27 0 00-.39-.08l-1.16.68c-.61.35-1.1-.13-1.1-1.05v-9.28a2.88 2.88 0 011.1-2.31l13.62-7.86c.6-.35 1.09.12 1.09 1v5.09c0 .41.22.61.48.46a1.26 1.26 0 00.49-1v-5.02c0-1.74-.93-2.63-2.06-2l-13.62 7.87a5.43 5.43 0 00-2.06 4.35v9.27c0 1.75.92 2.64 2.06 2l.51-.3-.08 4.61c-.06.34 0 .63.18.72a.29.29 0 00.28 0 .82.82 0 00.28-.3l4.76-8.13a1.25 1.25 0 00.48-1c0-.46-.21-.69-.48-.51z"
            style={{
              WebkitTransformOrigin: 295.44,
              MsTransformOrigin: 295.44,
              transformOrigin: 295.44,
            }}
            fill="#FAFAFA"
            className="animable"
          ></path>
        </g>
        <g
          id="freepik--Phone--inject-66"
          className="animable"
          style={{
            WebkitTransformOrigin: 247.08,
            MsTransformOrigin: 247.08,
            transformOrigin: 247.08,
          }}
        >
          <g
            id="freepik--box--inject-66"
            className="animable"
            style={{
              WebkitTransformOrigin: 247.08,
              MsTransformOrigin: 247.08,
              transformOrigin: 247.08,
            }}
          >
            <path
              d="M265.69 242.29a4.76 4.76 0 00-2.16-3.73l-1.75-1a4.72 4.72 0 00-4.3 0l-26.86 15.53a4.76 4.76 0 00-2.15 3.73v29.56a4.73 4.73 0 002.15 3.72l1.75 1a4.72 4.72 0 004.3 0l26.86-15.53a4.78 4.78 0 002.16-3.73z"
              style={{
                WebkitTransformOrigin: 247.08,
                MsTransformOrigin: 247.08,
                transformOrigin: 247.08,
              }}
              id="elgva7rxkd44o"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M228.47 286.37a4.73 4.73 0 002.15 3.72l1.75 1a4.8 4.8 0 003.93.18c-1 .38-1.78-.19-1.78-1.42v-29.54a4.36 4.36 0 01.63-2.12l-6.05-3.5a4.36 4.36 0 00-.63 2.12z"
              style={{
                WebkitTransformOrigin: 232.385,
                MsTransformOrigin: 232.385,
                transformOrigin: 232.385,
              }}
              id="elb1ddzsfwxd8"
              className="animable"
              opacity="0.2"
            ></path>
            <path
              d="M265.61 241.67c-.25-.91-1.08-1.2-2.07-.63l-26.87 15.54a4.2 4.2 0 00-1.51 1.61l-6.06-3.5a4.43 4.43 0 011.52-1.6l26.86-15.54a4.79 4.79 0 014.3 0l1.76 1a4.75 4.75 0 012.07 3.12z"
              style={{
                WebkitTransformOrigin: 247.355,
                MsTransformOrigin: 247.355,
                transformOrigin: 247.355,
              }}
              id="el4oaxmt7bqh3"
              fill="#FFF"
              className="animable"
              opacity="0.3"
            ></path>
          </g>
          <g
            id="freepik--phone--inject-66"
            className="animable"
            style={{
              WebkitTransformOrigin: 249.955,
              MsTransformOrigin: 249.955,
              transformOrigin: 249.955,
            }}
          >
            <path
              d="M254.08 276.92h-.15c-6-.51-10.16-4.57-12.5-12.05a8.61 8.61 0 012.12-8.13A2 2 0 01245 256c1.31 0 3.51 3.66 3.56 5.11a5.13 5.13 0 01-.95 2.88 3.35 3.35 0 00-.44 3.07c.71 2.06 1.88 3.15 3.57 3.36.44.05.83-.37 1.14-1.26.52-1.51 1.16-2.4 2-2.72a2 2 0 011.7.13l.27.13a13.63 13.63 0 011.39.76l.24.15c.84.51 1.57 1.13 1.16 3.16s-2 5.15-3.48 6a.49.49 0 01-.19.07h-.14a3.27 3.27 0 01-.75.08zM245 257.09c-.12 0-.34.15-.59.42a7.46 7.46 0 00-1.87 7c2.22 7.09 6 10.77 11.52 11.24a1.47 1.47 0 00.5-.07h.1c1.06-.67 2.45-3.19 2.86-5.18.28-1.41-.08-1.63-.64-2l-.28-.17a11.65 11.65 0 00-1.26-.69l-.28-.14a.84.84 0 00-.76-.09c-.32.13-.81.59-1.31 2-.63 1.83-1.63 2.11-2.34 2-2.14-.26-3.66-1.65-4.51-4.12a4.44 4.44 0 01.54-4 4 4 0 00.79-2.24c-.08-1.05-1.95-3.8-2.47-3.96z"
              style={{
                WebkitTransformOrigin: 249.955,
                MsTransformOrigin: 249.955,
                transformOrigin: 249.955,
              }}
              id="elrbuluuo612p"
              fill="#FAFAFA"
              className="animable"
            ></path>
          </g>
        </g>
      </g>
      <g
        id="freepik--Window--inject-66"
        className="animable animator-active"
        style={{
          WebkitTransformOrigin: 291.985,
          MsTransformOrigin: 291.985,
          transformOrigin: 291.985,
        }}
      >
        <g
          id="freepik--window--inject-66"
          className="animable"
          style={{
            WebkitTransformOrigin: 291.985,
            MsTransformOrigin: 291.985,
            transformOrigin: 291.985,
          }}
        >
          <path
            d="M346.42 23.6L230.68 90.33a5.75 5.75 0 00-2.6 4.51v133.83a5.74 5.74 0 002.61 4.5l1.63.93a5.79 5.79 0 005.21 0l115.74-66.84a5.76 5.76 0 002.61-4.51V29a5.71 5.71 0 00-2.62-4.5l-1.62-.93a5.78 5.78 0 00-5.22.03z"
            style={{
              WebkitTransformOrigin: 291.98,
              MsTransformOrigin: 291.98,
              transformOrigin: 291.98,
            }}
            id="elrlla6vm98xe"
            fill="#E0E0E0"
            className="animable"
          ></path>
          <path
            d="M355.88 162.92c0 2.29-1.61 3.75-3.61 4.9L238.53 233.5c-2 1.14-3.6.22-3.6-2.08V99.89a7.16 7.16 0 013.58-6.21L352.27 28a2.41 2.41 0 013.61 2.08z"
            style={{
              WebkitTransformOrigin: 295.405,
              MsTransformOrigin: 295.405,
              transformOrigin: 295.405,
            }}
            id="eldddmbatu26a"
            fill="#FAFAFA"
            className="animable"
          ></path>
          <path
            d="M353.47 28.65a1.4 1.4 0 011.4 1.4v132.87c0 1.56-.95 2.8-3.1 4L238 232.63a2.39 2.39 0 01-1.11.36c-.86 0-1-1-1-1.57V99.89a6.18 6.18 0 013.11-5.34l113.77-65.71a1.37 1.37 0 01.7-.19m0-1a2.34 2.34 0 00-1.2.33l-113.76 65.7a7.16 7.16 0 00-3.58 6.21v131.53c0 1.63.81 2.57 2 2.57a3.29 3.29 0 001.61-.49l113.74-65.68c2-1.15 3.61-2.61 3.61-4.9V30.05a2.42 2.42 0 00-2.41-2.41z"
            style={{
              WebkitTransformOrigin: 295.41,
              MsTransformOrigin: 295.41,
              transformOrigin: 295.41,
            }}
            id="elmob8gzz59jf"
            fill="#E0E0E0"
            className="animable"
          ></path>
          <path
            d="M355.88 29v1a2.41 2.41 0 00-3.61-2L238.51 93.68a7.08 7.08 0 00-2.62 2.62v.08l-7-4.06a5.39 5.39 0 011.88-2L346.42 23.6a5.73 5.73 0 015.21 0l1.63.93a5.73 5.73 0 012.62 4.47z"
            style={{
              WebkitTransformOrigin: 292.385,
              MsTransformOrigin: 292.385,
              transformOrigin: 292.385,
            }}
            id="elkqu1ye65owc"
            fill="#F0F0F0"
            className="animable"
          ></path>
          <path
            d="M249.39 124h-.16l-.08-.08-1.72-3v3.9a.54.54 0 01-.05.21.24.24 0 01-.12.14l-.49.29h-.12a.21.21 0 01-.05-.15v-6.11a.54.54 0 01.05-.21.24.24 0 01.12-.14l.43-.25h.16l.08.09 1.72 2.94v-3.9a.54.54 0 01.05-.21.28.28 0 01.12-.14l.49-.29a.1.1 0 01.12 0 .21.21 0 01.05.15v6.12a.54.54 0 01-.05.21.33.33 0 01-.12.14z"
            style={{
              WebkitTransformOrigin: 248.295,
              MsTransformOrigin: 248.295,
              transformOrigin: 248.295,
            }}
            id="elzj7ymuubgm"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M250.89 119.39a2.88 2.88 0 01.12-.49 2.83 2.83 0 01.25-.57 3 3 0 01.4-.56 2.17 2.17 0 01.55-.45 1.33 1.33 0 01.56-.19.56.56 0 01.44.12.93.93 0 01.28.46 2.89 2.89 0 01.1.8v2.78a.54.54 0 01-.05.21c0 .07-.07.12-.12.14l-.47.27a.08.08 0 01-.11 0 .17.17 0 01-.05-.15v-.31a2.72 2.72 0 01-.38.68 1.79 1.79 0 01-.61.55 1.21 1.21 0 01-.48.17.48.48 0 01-.35-.11.87.87 0 01-.22-.34 1.75 1.75 0 01-.07-.55 2.42 2.42 0 01.3-1.19 3.37 3.37 0 01.8-1l1-.84c0-.26-.06-.41-.17-.46a.51.51 0 00-.41.08 1 1 0 00-.24.2 2.29 2.29 0 00-.17.28.55.55 0 01-.1.16.28.28 0 01-.1.09l-.57.33h-.11c-.03 0-.02-.04-.02-.11zm1 2.08a1.56 1.56 0 00.37-.31 1.91 1.91 0 00.28-.4 2.5 2.5 0 00.16-.43 1.64 1.64 0 00.06-.42v-.1l-.84.71a1.45 1.45 0 00-.36.41.71.71 0 00-.11.4c0 .14 0 .21.13.22a.5.5 0 00.34-.08z"
            style={{
              WebkitTransformOrigin: 252.135,
              MsTransformOrigin: 252.135,
              transformOrigin: 252.135,
            }}
            id="elgw19een8maq"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M255.2 116.16a2.47 2.47 0 01.36-.62 1.36 1.36 0 01.44-.4.82.82 0 01.63-.15.75.75 0 01.39.36 3.57 3.57 0 01.19-.45 3 3 0 01.25-.4 2.21 2.21 0 01.28-.32 2.47 2.47 0 01.26-.18.86.86 0 01.59-.15.58.58 0 01.38.26 1.63 1.63 0 01.2.59 5 5 0 01.06.81V118a.54.54 0 01-.05.21.42.42 0 01-.12.14l-.47.27a.08.08 0 01-.11 0 .17.17 0 01-.05-.15V116a1.35 1.35 0 00-.16-.81c-.11-.11-.26-.1-.45 0a1 1 0 00-.42.49 2.25 2.25 0 00-.19 1v2.54a.54.54 0 01-.05.21.24.24 0 01-.12.14l-.46.27h-.12a.25.25 0 01-.05-.16v-2.5a1.26 1.26 0 00-.16-.8q-.17-.16-.45 0a1.17 1.17 0 00-.43.51 2.29 2.29 0 00-.18 1v2.5a.46.46 0 01-.16.35l-.47.27a.11.11 0 01-.12 0 .21.21 0 010-.15v-4.41a.54.54 0 010-.21.35.35 0 01.12-.14l.47-.28a.09.09 0 01.11 0 .2.2 0 010 .15z"
            style={{
              WebkitTransformOrigin: 256.828,
              MsTransformOrigin: 256.828,
              transformOrigin: 256.828,
            }}
            id="el41he6bmp71h"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M259.89 115.44a5.45 5.45 0 01.11-1.06 5.18 5.18 0 01.3-1 3.61 3.61 0 01.48-.81 2 2 0 01.62-.56 1 1 0 01.63-.17.71.71 0 01.47.25 1.56 1.56 0 01.31.59 3.17 3.17 0 01.1.86v.46a.41.41 0 01-.05.21.37.37 0 01-.11.15l-2.06 1.18a.85.85 0 00.06.35.38.38 0 00.16.19.34.34 0 00.23 0 .77.77 0 00.26-.1 1.16 1.16 0 00.32-.24 1.31 1.31 0 00.2-.28l.11-.16a.4.4 0 01.12-.1l.49-.28h.12s.05.08.05.16a1.38 1.38 0 01-.1.39 3 3 0 01-.26.56 4.58 4.58 0 01-.44.6 2.92 2.92 0 01-.61.49 1.06 1.06 0 01-.62.17.64.64 0 01-.48-.25 1.54 1.54 0 01-.3-.63 4 4 0 01-.11-.97zm1.51-2.29a1.08 1.08 0 00-.3.26 1.15 1.15 0 00-.21.33 1.78 1.78 0 00-.14.36 2.33 2.33 0 00-.06.33l1.39-.8a1.26 1.26 0 000-.27.46.46 0 00-.11-.22.26.26 0 00-.21-.09.61.61 0 00-.36.1z"
            style={{
              WebkitTransformOrigin: 261.4,
              MsTransformOrigin: 261.4,
              transformOrigin: 261.4,
            }}
            id="elw48g79fmlol"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M268.94 91a2.15 2.15 0 00-.56.47 2.85 2.85 0 00-.37.6 4.11 4.11 0 00-.21.68c0 .24-.08.48-.1.73s0 .32 0 .56v1.98a3.38 3.38 0 00.1.61 1.13 1.13 0 00.21.44.52.52 0 00.38.17 1 1 0 00.55-.18 2.18 2.18 0 00.49-.37 2.22 2.22 0 00.39-.51 3.12 3.12 0 00.27-.67 3.58 3.58 0 00.09-.83l-.82.48a.15.15 0 01-.19 0 .36.36 0 01-.08-.25v-1.6a.88.88 0 01.08-.34.56.56 0 01.19-.23l2.38-1.37a.15.15 0 01.19 0 .36.36 0 01.07.25v1.93a7.28 7.28 0 01-.23 1.88 8.12 8.12 0 01-.65 1.69 6.67 6.67 0 01-1 1.38 4.87 4.87 0 01-1.21 1 2.58 2.58 0 01-1.26.4 1.39 1.39 0 01-.95-.34 2.09 2.09 0 01-.6-1 5.53 5.53 0 01-.25-1.44V95.8v-1.38a8.78 8.78 0 01.24-1.72 8.67 8.67 0 01.61-1.66 6.59 6.59 0 01.95-1.43 4.87 4.87 0 011.26-1.06 2.63 2.63 0 011.24-.4 1.59 1.59 0 01.94.24 1.87 1.87 0 01.6.7 2.56 2.56 0 01.24 1 .66.66 0 01-.06.27.52.52 0 01-.16.19l-1.31.75c-.1.06-.18.06-.23 0l-.16-.18a.82.82 0 00-.38-.28q-.2-.07-.69.16z"
            style={{
              WebkitTransformOrigin: 268.926,
              MsTransformOrigin: 268.926,
              transformOrigin: 268.926,
            }}
            id="elribbf0cn0n9"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M274.53 93.07a1.2 1.2 0 00.09.53.42.42 0 00.21.24.44.44 0 00.28 0 1.2 1.2 0 00.31-.13 2 2 0 00.47-.36 1.84 1.84 0 00.29-.42l.15-.27a.63.63 0 01.17-.13l1.28-.74c.14-.08.22 0 .22.21a2.53 2.53 0 01-.15.64 6.17 6.17 0 01-.46 1 7.45 7.45 0 01-.8 1.14 4.55 4.55 0 01-1.17 1 2.33 2.33 0 01-1.14.37 1.09 1.09 0 01-.83-.32 2.16 2.16 0 01-.52-1 6.76 6.76 0 01-.17-1.62 9 9 0 01.17-1.72 7.5 7.5 0 01.52-1.6 5.63 5.63 0 01.83-1.33 4.2 4.2 0 011.14-1 1.94 1.94 0 011.22-.34 1.3 1.3 0 01.83.49 2.53 2.53 0 01.46 1.06 6.09 6.09 0 01.14 1.38v.42a.78.78 0 01-.07.43.57.57 0 01-.19.23zm.89-3.42a1.47 1.47 0 00-.63.75 3 3 0 00-.26 1l1.77-1a1.2 1.2 0 00-.25-.7c-.15-.2-.36-.2-.63-.05z"
            style={{
              WebkitTransformOrigin: 275.417,
              MsTransformOrigin: 275.417,
              transformOrigin: 275.417,
            }}
            id="elwwg6wkod2p"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M281.28 89.18a.9.9 0 00.1.48c.07.09.17.09.33 0l.78-.45a.14.14 0 01.19 0 .33.33 0 01.08.24V91a.8.8 0 01-.08.33.45.45 0 01-.19.23l-.93.54a1.73 1.73 0 01-.84.28.91.91 0 01-.65-.21 1.52 1.52 0 01-.41-.71 3.8 3.8 0 01-.15-1.16v-2.55l-.73.42a.14.14 0 01-.18 0 .29.29 0 01-.08-.24v-1.55a.67.67 0 01.08-.33.49.49 0 01.18-.23l.73-.42v-2.47a.8.8 0 01.08-.33.45.45 0 01.19-.23l1.24-.72a.13.13 0 01.18 0 .31.31 0 01.08.24v2.47l1.11-.65a.15.15 0 01.19 0 .33.33 0 01.08.24v1.53a.8.8 0 01-.08.33.45.45 0 01-.19.23l-1.11.64z"
            style={{
              WebkitTransformOrigin: 280.639,
              MsTransformOrigin: 280.639,
              transformOrigin: 280.639,
            }}
            id="elgbonpjnq6hw"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M287.45 79.57a.88.88 0 01-.08.34.49.49 0 01-.19.23l-1.24.71a.14.14 0 01-.18 0 .33.33 0 01-.08-.24v-1.54a.84.84 0 01.08-.34.54.54 0 01.18-.23l1.24-.71h.19a.33.33 0 01.08.24zm0 8.71a.8.8 0 01-.08.33.41.41 0 01-.19.23l-1.24.72a.14.14 0 01-.18 0 .34.34 0 01-.08-.25v-7a.84.84 0 01.08-.34.54.54 0 01.18-.23l1.24-.71h.19a.33.33 0 01.08.24z"
            style={{
              WebkitTransformOrigin: 286.565,
              MsTransformOrigin: 286.565,
              transformOrigin: 286.565,
            }}
            id="elq91n8b6dft"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M293.84 84.6a.8.8 0 01-.08.33.57.57 0 01-.19.23l-1.24.71a.15.15 0 01-.19 0 .33.33 0 01-.08-.24v-3.84a1.56 1.56 0 00-.2-.93c-.14-.18-.36-.19-.65 0a1.5 1.5 0 00-.65.77 3.2 3.2 0 00-.2 1.16v3.81a.67.67 0 01-.08.33.49.49 0 01-.18.23l-1.24.72h-.19a.37.37 0 01-.08-.25v-7.07a.8.8 0 01.08-.33.45.45 0 01.19-.23l1.19-.68a.14.14 0 01.19 0 .33.33 0 01.07.24v.35c.06-.13.12-.28.2-.43a2.52 2.52 0 01.29-.46 3.86 3.86 0 01.38-.44 2.58 2.58 0 01.52-.38 2.06 2.06 0 01.87-.3.91.91 0 01.67.24 1.8 1.8 0 01.44.83 5.7 5.7 0 01.16 1.45z"
            style={{
              WebkitTransformOrigin: 291.215,
              MsTransformOrigin: 291.215,
              transformOrigin: 291.215,
            }}
            id="ela8eit6rtjv9"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M299.18 78.85a.82.82 0 00.1.48c.06.09.17.09.32 0l.79-.46a.14.14 0 01.18 0 .29.29 0 01.08.24v1.53a.67.67 0 01-.08.33.49.49 0 01-.18.23l-.94.54a1.85 1.85 0 01-.84.28.85.85 0 01-.64-.22 1.44 1.44 0 01-.42-.7 3.87 3.87 0 01-.14-1.16v-2.53l-.73.42a.14.14 0 01-.19 0 .33.33 0 01-.08-.24v-1.54a.8.8 0 01.08-.33.5.5 0 01.19-.23l.73-.42V72.6a.78.78 0 01.07-.33.51.51 0 01.19-.23l1.24-.72a.15.15 0 01.19 0 .34.34 0 01.08.25V74l1.11-.64a.15.15 0 01.19 0 .33.33 0 01.07.24v1.53a.78.78 0 01-.07.33.57.57 0 01-.19.23l-1.11.64z"
            style={{
              WebkitTransformOrigin: 298.531,
              MsTransformOrigin: 298.531,
              transformOrigin: 298.531,
            }}
            id="elvxp8yqbcvhq"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M306.62 73.11v1.16a6.37 6.37 0 01-.21 1.49 7 7 0 01-.54 1.43 6.17 6.17 0 01-.83 1.23 4.39 4.39 0 01-1.09.9 2.23 2.23 0 01-1.09.35 1.21 1.21 0 01-.83-.27 1.77 1.77 0 01-.54-.8 4 4 0 01-.22-1.24v-.57-.59a6.52 6.52 0 01.21-1.49 6.94 6.94 0 01.54-1.42 6.43 6.43 0 01.84-1.24 4.23 4.23 0 011.09-.91 2.23 2.23 0 011.09-.35 1.26 1.26 0 01.83.28 1.63 1.63 0 01.54.8 3.78 3.78 0 01.21 1.24zM303 76.27a1 1 0 00.27.74.56.56 0 00.64 0 1.63 1.63 0 00.63-.69 2.59 2.59 0 00.27-1.06 4.35 4.35 0 000-.53 3.78 3.78 0 000-.5 1 1 0 00-.27-.74c-.16-.13-.37-.12-.63 0a1.65 1.65 0 00-.64.69 2.55 2.55 0 00-.27 1.06v1.03z"
            style={{
              WebkitTransformOrigin: 303.945,
              MsTransformOrigin: 303.945,
              transformOrigin: 303.945,
            }}
            id="eleks4nb8ch7e"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M307.5 69.65a.8.8 0 01.08-.33.44.44 0 01.18-.23l1.25-.72a.14.14 0 01.18 0 .36.36 0 01.08.25v3.83a1.76 1.76 0 00.19.94c.12.19.33.2.62 0a1.35 1.35 0 00.61-.75 3.35 3.35 0 00.18-1.15V67.7a.8.8 0 01.08-.33.51.51 0 01.19-.23l1.24-.72a.15.15 0 01.19 0 .37.37 0 01.07.25v7.06a.78.78 0 01-.07.33.57.57 0 01-.19.23l-1.14.66a.15.15 0 01-.19 0 .33.33 0 01-.08-.24v-.35a3.25 3.25 0 01-.19.44 2.76 2.76 0 01-.28.45 3.85 3.85 0 01-.39.44 2.58 2.58 0 01-.52.38c-.64.37-1.15.38-1.52 0a3.19 3.19 0 01-.57-2.3z"
            style={{
              WebkitTransformOrigin: 310.056,
              MsTransformOrigin: 310.056,
              transformOrigin: 310.056,
            }}
            id="elw8rjllg7rqe"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M315.35 68.11v1.07a1 1 0 00.27.72c.15.13.36.12.62 0a1.54 1.54 0 00.5-.43 2 2 0 00.28-.56 1.81 1.81 0 01.12-.28.4.4 0 01.17-.19l1.29-.75a.17.17 0 01.19 0 .31.31 0 01.07.25 4.3 4.3 0 01-.13.79 5.08 5.08 0 01-.41 1.16 6.08 6.08 0 01-.8 1.27 4.4 4.4 0 01-1.28 1.08 2.39 2.39 0 01-1 .35 1.27 1.27 0 01-.84-.22 1.63 1.63 0 01-.57-.76 3.77 3.77 0 01-.23-1.32v-.6-.61a6.42 6.42 0 01.23-1.58 6.88 6.88 0 01.57-1.43 6 6 0 01.84-1.18 4.38 4.38 0 011-.83 2.31 2.31 0 011.28-.4 1.34 1.34 0 01.8.34 1.51 1.51 0 01.41.7 2.4 2.4 0 01.13.64.64.64 0 01-.07.32.54.54 0 01-.19.24l-1.29.74a.15.15 0 01-.17 0 .61.61 0 01-.12-.15.44.44 0 00-.28-.24.74.74 0 00-.5.15 1.55 1.55 0 00-.62.69 2.58 2.58 0 00-.27 1.02z"
            style={{
              WebkitTransformOrigin: 316.232,
              MsTransformOrigin: 316.232,
              transformOrigin: 316.232,
            }}
            id="elmkwo9z2t6pr"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M325 66.63a.67.67 0 01-.08.33.49.49 0 01-.18.23l-1.24.72h-.19a.33.33 0 01-.08-.24v-3.85a1.69 1.69 0 00-.2-.93c-.14-.18-.36-.18-.65 0a1.44 1.44 0 00-.65.76 3.24 3.24 0 00-.2 1.16v3.83a.81.81 0 01-.08.34.45.45 0 01-.19.23l-1.24.71a.13.13 0 01-.18 0 .29.29 0 01-.08-.24v-9.96a.67.67 0 01.08-.33.49.49 0 01.18-.23l1.24-.72a.15.15 0 01.19 0 .33.33 0 01.08.24v3.23A4.2 4.2 0 01322 61a2.71 2.71 0 01.82-.77 1.91 1.91 0 01.86-.29.85.85 0 01.68.24 1.75 1.75 0 01.43.82 5.28 5.28 0 01.16 1.45z"
            style={{
              WebkitTransformOrigin: 322.379,
              MsTransformOrigin: 322.379,
              transformOrigin: 322.379,
            }}
            id="el2u10eg7zzf4"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 296.06,
              MsTransformOrigin: 296.06,
              transformOrigin: 296.06,
            }}
            id="el8bqkuj5ex2h"
            fill="#E0E0E0"
            d="M246.07 130.3L346.05 72.57 346.05 81.45 246.07 139.18 246.07 130.3z"
            className="animable"
          ></path>
          <path
            d="M249.47 149.38a.09.09 0 01.11 0 .17.17 0 010 .15v.67a.41.41 0 010 .21.37.37 0 01-.11.15l-2.7 1.55h-.12a.25.25 0 01-.05-.16v-6.11a.54.54 0 01.05-.21.24.24 0 01.12-.14l2.65-1.53a.07.07 0 01.11 0 .17.17 0 01.05.15v.67a.41.41 0 01-.05.21.27.27 0 01-.11.14l-2 1.15v1.5l1.85-1.07a.1.1 0 01.12 0 .21.21 0 010 .15v.68a.49.49 0 010 .2.31.31 0 01-.12.15l-1.84 1.11v1.57z"
            style={{
              WebkitTransformOrigin: 248.099,
              MsTransformOrigin: 248.099,
              transformOrigin: 248.099,
            }}
            id="elr2esieedl5"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M251.14 145.15a2.73 2.73 0 01.36-.63 1.59 1.59 0 01.43-.4.87.87 0 01.64-.14.64.64 0 01.38.36 3.44 3.44 0 01.45-.85 3 3 0 01.27-.32 1.57 1.57 0 01.33-.17.91.91 0 01.58-.16.55.55 0 01.38.27 1.41 1.41 0 01.2.58 5.17 5.17 0 01.06.82V147a.37.37 0 010 .2.37.37 0 01-.11.15l-.47.27a.1.1 0 01-.12 0 .21.21 0 010-.15V145a1.28 1.28 0 00-.16-.81q-.15-.16-.45 0a1.22 1.22 0 00-.42.49 2.33 2.33 0 00-.18 1v2.55a.54.54 0 010 .21.34.34 0 01-.12.14l-.47.27a.08.08 0 01-.11 0 .17.17 0 010-.15v-2.5a1.35 1.35 0 00-.16-.81c-.11-.1-.26-.1-.45 0a1.17 1.17 0 00-.43.51 2.24 2.24 0 00-.18 1v2.5a.54.54 0 010 .21.31.31 0 01-.12.15l-.46.27a.1.1 0 01-.12 0 .21.21 0 010-.15v-4.42a.49.49 0 010-.2.31.31 0 01.12-.15l.46-.27a.1.1 0 01.12 0 .21.21 0 010 .15z"
            style={{
              WebkitTransformOrigin: 252.955,
              MsTransformOrigin: 252.955,
              transformOrigin: 252.955,
            }}
            id="el48fedxrrdav"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M256 143.09a2.77 2.77 0 01.11-.49 3.25 3.25 0 01.26-.58 2.57 2.57 0 01.4-.55 2 2 0 01.55-.45 1.31 1.31 0 01.56-.2.62.62 0 01.44.13.89.89 0 01.28.46 2.94 2.94 0 01.09.8V145a.41.41 0 01-.05.21.33.33 0 01-.11.14l-.47.27a.09.09 0 01-.12 0 .21.21 0 01-.05-.15v-.31a2.4 2.4 0 01-.37.68 1.94 1.94 0 01-.62.55 1.12 1.12 0 01-.47.17.51.51 0 01-.35-.11.77.77 0 01-.22-.34 1.77 1.77 0 01-.08-.55 2.49 2.49 0 01.31-1.2 3.47 3.47 0 01.8-1l1-.85c0-.25-.05-.41-.16-.45a.47.47 0 00-.41.08.61.61 0 00-.24.2 1.48 1.48 0 00-.17.28l-.1.16a.41.41 0 01-.1.09l-.57.33a.11.11 0 01-.11 0s-.03-.04-.03-.11zm1 2.07a1.52 1.52 0 00.37-.3 1.76 1.76 0 00.27-.4 1.82 1.82 0 00.17-.44 1.51 1.51 0 00.05-.42v-.09l-.83.71a1.42 1.42 0 00-.36.4.78.78 0 00-.12.41c0 .13.05.21.14.22a.53.53 0 00.31-.09z"
            style={{
              WebkitTransformOrigin: 257.235,
              MsTransformOrigin: 257.235,
              transformOrigin: 257.235,
            }}
            id="elladvpd5cqgf"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M260.17 137.67a.07.07 0 01.11 0 .21.21 0 01.05.15v.74a.49.49 0 01-.05.2.37.37 0 01-.11.15l-.53.3h-.12a.21.21 0 010-.15v-.74a.49.49 0 010-.2.31.31 0 01.12-.15zm.13 6.38a.54.54 0 01-.05.21.31.31 0 01-.12.15l-.46.27a.1.1 0 01-.12 0 .21.21 0 01-.05-.15v-4.43a.53.53 0 01.05-.2.31.31 0 01.12-.15l.46-.27a.1.1 0 01.12 0 .21.21 0 01.05.15z"
            style={{
              WebkitTransformOrigin: 259.915,
              MsTransformOrigin: 259.915,
              transformOrigin: 259.915,
            }}
            id="elx6k5zzem6hq"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M262 143.1a.54.54 0 01-.05.21.31.31 0 01-.12.15l-.46.26h-.12a.25.25 0 01-.05-.16v-6.2a.54.54 0 01.05-.21.31.31 0 01.12-.15l.46-.27a.1.1 0 01.12 0 .21.21 0 01.05.15z"
            style={{
              WebkitTransformOrigin: 261.6,
              MsTransformOrigin: 261.6,
              transformOrigin: 261.6,
            }}
            id="elnqyivth24eh"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M264.2 138.35a2.77 2.77 0 01.11-.49 2.88 2.88 0 01.26-.57 2.39 2.39 0 01.4-.56 2 2 0 01.55-.45 1.41 1.41 0 01.56-.2.58.58 0 01.43.13.78.78 0 01.28.46 2.56 2.56 0 01.1.8v2.78a.41.41 0 01-.05.21.33.33 0 01-.11.14l-.47.27a.09.09 0 01-.12 0 .21.21 0 01-.05-.15v-.31a2.67 2.67 0 01-.37.68 1.94 1.94 0 01-.62.55 1.12 1.12 0 01-.47.17.51.51 0 01-.35-.11.7.7 0 01-.22-.34 1.73 1.73 0 01-.08-.55 2.43 2.43 0 01.31-1.19 3.37 3.37 0 01.8-1l1-.85c0-.25 0-.4-.16-.45a.47.47 0 00-.41.08.71.71 0 00-.24.2 1.48 1.48 0 00-.17.28l-.1.16a.41.41 0 01-.1.09l-.58.33a.09.09 0 01-.1 0s-.04-.04-.03-.11zm1 2.07a1.74 1.74 0 00.37-.3 1.76 1.76 0 00.27-.4 1.82 1.82 0 00.17-.44 2 2 0 000-.42v-.09l-.83.71a1.67 1.67 0 00-.37.4.87.87 0 00-.11.41c0 .14.05.21.14.22a.53.53 0 00.39-.09z"
            style={{
              WebkitTransformOrigin: 265.436,
              MsTransformOrigin: 265.436,
              transformOrigin: 265.436,
            }}
            id="elb90882jv0ri"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M268.94 134.31a1 1 0 01.34-.14.64.64 0 01.27 0 .54.54 0 01.19.08.47.47 0 01.13.11v-2a.54.54 0 01.05-.21.33.33 0 01.08-.15l.47-.27a.09.09 0 01.12 0 .21.21 0 01.05.15v6.21a.54.54 0 01-.05.21.28.28 0 01-.12.14l-.47.27a.08.08 0 01-.11 0 .21.21 0 01-.05-.15v-.22c0 .08-.08.16-.13.26a2.49 2.49 0 01-.19.3 2.44 2.44 0 01-.27.29 1.8 1.8 0 01-.34.26.82.82 0 01-.56.13.7.7 0 01-.42-.24 1.5 1.5 0 01-.28-.55 3.06 3.06 0 01-.11-.78 3.11 3.11 0 010-.32v-.34a4.8 4.8 0 01.11-.9 4.66 4.66 0 01.28-.87 4.07 4.07 0 01.42-.74 1.75 1.75 0 01.59-.53zm-.57 2.62a4.68 4.68 0 000 .53c0 .39.1.64.24.74a.45.45 0 00.51 0 1.36 1.36 0 00.51-.57 2.2 2.2 0 00.24-.93v-.36a3.33 3.33 0 000-.35.89.89 0 00-.24-.65.45.45 0 00-.51 0 1.43 1.43 0 00-.51.57 2.41 2.41 0 00-.24 1.02z"
            style={{
              WebkitTransformOrigin: 269.088,
              MsTransformOrigin: 269.088,
              transformOrigin: 269.088,
            }}
            id="eltd96g8jmlg8"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M272.75 132.11a.94.94 0 01.34-.14.58.58 0 01.26 0 .43.43 0 01.2.07l.13.11v-2a.52.52 0 010-.21.58.58 0 01.12-.14l.47-.27a.09.09 0 01.11 0 .17.17 0 01.05.15v6.21a.41.41 0 01-.05.21.27.27 0 01-.11.14l-.47.27a.09.09 0 01-.12 0 .25.25 0 010-.16v-.21l-.13.25a2.61 2.61 0 01-.2.3 2.32 2.32 0 01-.26.3 2.13 2.13 0 01-.34.25.9.9 0 01-.56.14.66.66 0 01-.42-.25 1.5 1.5 0 01-.28-.55 2.65 2.65 0 01-.11-.77v-.33-.34a4.1 4.1 0 01.11-.9 4.66 4.66 0 01.28-.87 3.15 3.15 0 01.42-.74 1.87 1.87 0 01.56-.52zm-.58 2.62a4.68 4.68 0 000 .53c0 .39.11.64.25.74a.45.45 0 00.51 0 1.43 1.43 0 00.51-.57 2.35 2.35 0 00.24-.92v-.37-.35a.89.89 0 00-.24-.64.42.42 0 00-.51 0 1.34 1.34 0 00-.51.56 2.55 2.55 0 00-.25 1.02z"
            style={{
              WebkitTransformOrigin: 272.906,
              MsTransformOrigin: 272.906,
              transformOrigin: 272.906,
            }}
            id="eln48qqp88gon"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M276.82 131a1.27 1.27 0 00-.54.56 2.28 2.28 0 00-.16.91v2.46a.41.41 0 01-.05.21.27.27 0 01-.11.14l-.47.27a.09.09 0 01-.12 0 .21.21 0 01-.05-.15V131a.54.54 0 01.05-.21.24.24 0 01.12-.14l.47-.27a.08.08 0 01.11 0 .17.17 0 01.05.15v.22a3.07 3.07 0 01.34-.55 1.6 1.6 0 01.48-.4l.28-.16a.09.09 0 01.11 0 .17.17 0 01.05.15v.63a.35.35 0 01-.05.2.37.37 0 01-.11.15z"
            style={{
              WebkitTransformOrigin: 276.351,
              MsTransformOrigin: 276.351,
              transformOrigin: 276.351,
            }}
            id="elyp4tlgmobmj"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M277.68 131.81a5.53 5.53 0 01.11-1.06 4.87 4.87 0 01.3-1 3.47 3.47 0 01.48-.82 2 2 0 01.62-.56 1 1 0 01.62-.17.71.71 0 01.48.25 1.49 1.49 0 01.31.59 3.22 3.22 0 01.1.86v.42a.41.41 0 01-.05.21.37.37 0 01-.11.15l-2.06 1.18a.85.85 0 00.06.35.38.38 0 00.16.19.34.34 0 00.23 0 .77.77 0 00.26-.1 1.16 1.16 0 00.32-.24 1.31 1.31 0 00.2-.28c.05-.07.08-.13.11-.16a.4.4 0 01.12-.1l.49-.28h.12a.17.17 0 01.05.15 1.35 1.35 0 01-.1.4 3.88 3.88 0 01-.26.56 4.58 4.58 0 01-.44.6 2.63 2.63 0 01-.61.49 1.16 1.16 0 01-.62.18.68.68 0 01-.48-.26 1.54 1.54 0 01-.3-.63 4 4 0 01-.11-.92zm1.51-2.29a1.08 1.08 0 00-.3.26 1.46 1.46 0 00-.22.33 2.6 2.6 0 00-.13.36 2.33 2.33 0 00-.06.33l1.39-.8a1.26 1.26 0 000-.27.57.57 0 00-.11-.22.27.27 0 00-.21-.09.61.61 0 00-.36.1z"
            style={{
              WebkitTransformOrigin: 279.19,
              MsTransformOrigin: 279.19,
              transformOrigin: 279.19,
            }}
            id="el8vo9yo2jba7"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M283.11 129.73a.21.21 0 000-.15.21.21 0 00-.15 0 1.35 1.35 0 00-.29 0l-.45.11a1 1 0 01-.45 0 .52.52 0 01-.29-.16.81.81 0 01-.15-.35 3.49 3.49 0 010-.5 2.31 2.31 0 01.09-.61 2.75 2.75 0 01.25-.63 3 3 0 01.39-.57 2 2 0 01.54-.44 1.45 1.45 0 01.53-.21.77.77 0 01.41 0 .57.57 0 01.26.25.93.93 0 01.1.38.33.33 0 01-.05.21.31.31 0 01-.12.15l-.47.27a.16.16 0 01-.14 0l-.1-.06a.3.3 0 00-.15 0 .65.65 0 00-.27.11 1 1 0 00-.33.28.59.59 0 00-.14.38.35.35 0 000 .16.17.17 0 00.13.05h.27l.44-.11a.74.74 0 01.77.12 1.2 1.2 0 01.22.82 2.18 2.18 0 01-.09.6 2.73 2.73 0 01-.27.64 2.7 2.7 0 01-.43.59 2.5 2.5 0 01-.57.46 1.33 1.33 0 01-.58.21.72.72 0 01-.42-.06.62.62 0 01-.26-.27 1 1 0 01-.1-.41.39.39 0 010-.21.35.35 0 01.12-.14l.48-.28a.14.14 0 01.14 0l.1.09a.21.21 0 00.16.06.75.75 0 00.32-.12l.19-.12.18-.17.14-.19a.54.54 0 00.04-.18z"
            style={{
              WebkitTransformOrigin: 282.596,
              MsTransformOrigin: 282.596,
              transformOrigin: 282.596,
            }}
            id="el1crv8t3iz2v"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M286.31 127.88a.18.18 0 000-.14.21.21 0 00-.15 0h-.29l-.45.11a1 1 0 01-.45 0 .5.5 0 01-.29-.17.76.76 0 01-.15-.34 2.53 2.53 0 010-.5 2.69 2.69 0 01.08-.61 3.07 3.07 0 01.65-1.21 2 2 0 01.53-.44 1.7 1.7 0 01.54-.21.73.73 0 01.4 0 .51.51 0 01.26.24.94.94 0 01.11.39.43.43 0 010 .21.24.24 0 01-.12.14l-.47.28h-.14l-.1-.06a.33.33 0 00-.15 0 .59.59 0 00-.28.11 1.18 1.18 0 00-.32.27.54.54 0 00-.14.38.32.32 0 000 .16.16.16 0 00.13.05h.26l.44-.11q.56-.14.78.12a1.22 1.22 0 01.22.82 2.31 2.31 0 01-.09.61 2.92 2.92 0 01-.27.64 3.41 3.41 0 01-.43.59 2.32 2.32 0 01-.58.45 1.41 1.41 0 01-.57.22.69.69 0 01-.42-.07.64.64 0 01-.27-.27.91.91 0 01-.09-.41.38.38 0 010-.2.49.49 0 01.12-.15l.48-.27h.13l.11.1a.25.25 0 00.16.05.55.55 0 00.31-.11l.2-.13.18-.17a1.33 1.33 0 00.14-.19.54.54 0 00-.01-.18z"
            style={{
              WebkitTransformOrigin: 285.846,
              MsTransformOrigin: 285.846,
              transformOrigin: 285.846,
            }}
            id="el4ob61iw4qva"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 296.06,
              MsTransformOrigin: 296.06,
              transformOrigin: 296.06,
            }}
            id="el7ky7020ynh4"
            fill="#E0E0E0"
            d="M246.07 156.94L346.05 99.21 346.05 108.09 246.07 165.82 246.07 156.94z"
            className="animable"
          ></path>
          <path
            d="M248.62 174.45l1.17-3.8a1.6 1.6 0 01.08-.2.46.46 0 01.18-.21l.42-.24a.11.11 0 01.12 0 .21.21 0 010 .15v6.12a.52.52 0 010 .21.43.43 0 01-.12.14l-.5.29a.11.11 0 01-.12 0 .21.21 0 010-.15v-3.7l-.79 2.59a1.13 1.13 0 01-.09.2.4.4 0 01-.14.17l-.32.18h-.14a.41.41 0 01-.09-.1l-.8-1.67v3.7a.54.54 0 01-.05.21.28.28 0 01-.12.14l-.49.29a.1.1 0 01-.12 0 .21.21 0 01-.05-.15v-6.12a.54.54 0 01.05-.21.28.28 0 01.12-.14l.41-.24c.09-.05.15-.05.19 0l.08.1z"
            style={{
              WebkitTransformOrigin: 248.627,
              MsTransformOrigin: 248.627,
              transformOrigin: 248.627,
            }}
            id="elli00hk9ymxp"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M251.38 173.64a5.51 5.51 0 01.1-1.06 4.87 4.87 0 01.3-1 3.84 3.84 0 01.48-.82 2.19 2.19 0 01.63-.56 1 1 0 01.62-.17.71.71 0 01.48.25 1.42 1.42 0 01.3.59 3.21 3.21 0 01.11.86v.42a.54.54 0 01-.05.21.31.31 0 01-.12.15l-2 1.18a.85.85 0 00.06.35.42.42 0 00.15.19.35.35 0 00.23 0 .64.64 0 00.27-.1 1.11 1.11 0 00.31-.24 1.37 1.37 0 00.21-.28.85.85 0 01.11-.16.4.4 0 01.12-.1l.49-.28a.09.09 0 01.12 0 .18.18 0 010 .16 1.29 1.29 0 01-.09.39 3.14 3.14 0 01-.27.56 3.82 3.82 0 01-.44.6 2.39 2.39 0 01-.6.49 1.17 1.17 0 01-.63.18.7.7 0 01-.48-.26 1.54 1.54 0 01-.3-.63 4 4 0 01-.11-.92zm1.51-2.29a1.13 1.13 0 00-.31.26 1.85 1.85 0 00-.21.33 1.74 1.74 0 00-.13.36 2.33 2.33 0 00-.06.33l1.39-.8a2.56 2.56 0 000-.27.46.46 0 00-.11-.22.25.25 0 00-.2-.09.58.58 0 00-.37.1z"
            style={{
              WebkitTransformOrigin: 252.89,
              MsTransformOrigin: 252.89,
              transformOrigin: 252.89,
            }}
            id="el0fn477y9dn7n"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M256.81 171.56a.27.27 0 000-.15.23.23 0 00-.16 0 1.28 1.28 0 00-.28.05l-.46.11a1 1 0 01-.44 0 .49.49 0 01-.29-.16.81.81 0 01-.15-.35 2.47 2.47 0 010-.5 2.28 2.28 0 01.08-.61 3.3 3.3 0 01.25-.63 3.09 3.09 0 01.4-.57 1.86 1.86 0 01.53-.44 1.42 1.42 0 01.54-.21.73.73 0 01.4 0 .53.53 0 01.26.25.94.94 0 01.11.39.53.53 0 010 .2.38.38 0 01-.12.15l-.47.27a.17.17 0 01-.14 0l-.1-.06a.24.24 0 00-.15 0 .63.63 0 00-.28.1 1.06 1.06 0 00-.32.28.55.55 0 00-.15.38.34.34 0 000 .16.14.14 0 00.13.05h.26l.44-.11c.37-.09.62 0 .77.12a1.2 1.2 0 01.23.82 2.18 2.18 0 01-.09.6 4 4 0 01-.27.64 3.07 3.07 0 01-.43.59 2.35 2.35 0 01-.58.46 1.34 1.34 0 01-.57.21.7.7 0 01-.42-.06.59.59 0 01-.27-.27 1.12 1.12 0 01-.1-.41.54.54 0 01.05-.21.24.24 0 01.12-.14l.47-.28h.14l.11.09a.21.21 0 00.16.06.61.61 0 00.31-.12 1 1 0 00.19-.12 1 1 0 00.18-.17.77.77 0 00.14-.19.42.42 0 00-.03-.22z"
            style={{
              WebkitTransformOrigin: 256.337,
              MsTransformOrigin: 256.337,
              transformOrigin: 256.337,
            }}
            id="eljj540knu7q"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M260 169.71a.18.18 0 00-.05-.14.21.21 0 00-.15 0 2.11 2.11 0 00-.28.05l-.46.11a1 1 0 01-.45 0 .48.48 0 01-.28-.17.59.59 0 01-.15-.34 2.49 2.49 0 01-.05-.5 2.25 2.25 0 01.09-.61 2.85 2.85 0 01.25-.63 3.27 3.27 0 01.39-.58 2.27 2.27 0 01.54-.44 1.86 1.86 0 01.54-.21.74.74 0 01.4 0 .55.55 0 01.26.24.93.93 0 01.1.39.39.39 0 010 .21.43.43 0 01-.12.14l-.48.27c-.06 0-.1.05-.13 0a.3.3 0 01-.11-.06.26.26 0 00-.14 0 .68.68 0 00-.28.11 1.4 1.4 0 00-.33.27.6.6 0 00-.14.39.22.22 0 000 .15h.39l.44-.11a.74.74 0 01.77.12 1.22 1.22 0 01.23.82 2.35 2.35 0 01-.1.61 3.44 3.44 0 01-.26.64 4.66 4.66 0 01-.43.59 2.74 2.74 0 01-.58.45 1.51 1.51 0 01-.58.22.72.72 0 01-.42-.07.62.62 0 01-.26-.27 1.08 1.08 0 01-.1-.41.39.39 0 01.05-.2.31.31 0 01.12-.15l.47-.27h.14l.1.09a.29.29 0 00.17.05.57.57 0 00.31-.11l.19-.13a1 1 0 00.18-.17.85.85 0 00.14-.19.42.42 0 00.06-.16z"
            style={{
              WebkitTransformOrigin: 259.437,
              MsTransformOrigin: 259.437,
              transformOrigin: 259.437,
            }}
            id="elvkwbbfy4xx"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M261.46 166.57a3.13 3.13 0 01.12-.49 2.83 2.83 0 01.25-.57 3 3 0 01.4-.56 2.13 2.13 0 01.55-.44 1.23 1.23 0 01.56-.2.6.6 0 01.44.12.93.93 0 01.28.46 3 3 0 01.1.8v2.78a.54.54 0 01-.05.21c0 .07-.07.12-.12.14l-.47.27a.08.08 0 01-.11 0 .21.21 0 01-.05-.16v-.31a2.72 2.72 0 01-.38.68 1.79 1.79 0 01-.61.55 1.07 1.07 0 01-.48.17.52.52 0 01-.35-.1.92.92 0 01-.22-.35 1.73 1.73 0 01-.07-.54 2.43 2.43 0 01.3-1.2 3.51 3.51 0 01.8-1l1-.84c0-.26-.06-.41-.17-.46a.51.51 0 00-.41.08.83.83 0 00-.24.21 1.59 1.59 0 00-.17.27.55.55 0 01-.1.16.28.28 0 01-.1.09l-.57.33a.08.08 0 01-.11 0s-.03-.03-.02-.1zm1 2.08a1.36 1.36 0 00.37-.31 1.56 1.56 0 00.27-.4 1.92 1.92 0 00.17-.43 1.64 1.64 0 00.06-.42V167l-.84.71a1.45 1.45 0 00-.36.41.72.72 0 00-.11.41c0 .13 0 .2.13.21a.44.44 0 00.34-.09z"
            style={{
              WebkitTransformOrigin: 262.705,
              MsTransformOrigin: 262.705,
              transformOrigin: 262.705,
            }}
            id="elzrm321ql44"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M266.37 168.4a1 1 0 00.26-.22 1.43 1.43 0 00.25-.33 2.53 2.53 0 00.18-.44 1.81 1.81 0 00.07-.52v-.35a2.08 2.08 0 01-.13.26c-.05.09-.12.19-.19.29a3.65 3.65 0 01-.27.3 1.76 1.76 0 01-.34.25.87.87 0 01-.55.14.71.71 0 01-.43-.25 1.49 1.49 0 01-.22-.53 3 3 0 01-.12-.77v-.67a4.84 4.84 0 01.12-.9 4.65 4.65 0 01.27-.87 3.58 3.58 0 01.43-.74 2 2 0 01.55-.5 1.29 1.29 0 01.34-.14.63.63 0 01.27 0 .4.4 0 01.19.07.5.5 0 01.13.11v-.22a.54.54 0 01.05-.21.28.28 0 01.12-.14l.46-.27a.09.09 0 01.12 0 .21.21 0 01.05.15v4.44a4.44 4.44 0 01-.41 2 2.89 2.89 0 01-1.15 1.24 1.52 1.52 0 01-.58.21.9.9 0 01-.47-.07.77.77 0 01-.31-.31 1 1 0 01-.13-.47.41.41 0 01.05-.21.31.31 0 01.12-.15l.41-.24a.12.12 0 01.15 0l.11.1a.28.28 0 00.22.14.74.74 0 00.38-.18zm-.74-3.25a4.68 4.68 0 000 .53c0 .4.11.64.25.74a.45.45 0 00.51 0 1.34 1.34 0 00.5-.57 2.19 2.19 0 00.24-.92v-.37-.35a.85.85 0 00-.24-.64.4.4 0 00-.5 0 1.34 1.34 0 00-.51.56 2.55 2.55 0 00-.25 1.02z"
            style={{
              WebkitTransformOrigin: 266.431,
              MsTransformOrigin: 266.431,
              transformOrigin: 266.431,
            }}
            id="elzl20qfcmhjg"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M268.62 163.69a5.44 5.44 0 01.1-1.06 4.57 4.57 0 01.31-1 4.08 4.08 0 01.47-.82 2.35 2.35 0 01.63-.56 1 1 0 01.62-.16.74.74 0 01.48.24 1.42 1.42 0 01.3.59 3.26 3.26 0 01.11.86v.43a.54.54 0 01-.05.21.24.24 0 01-.12.14l-2.05 1.19a.88.88 0 00.06.35.42.42 0 00.15.19.45.45 0 00.23 0 1 1 0 00.27-.1 1.69 1.69 0 00.32-.25 2.34 2.34 0 00.2-.27 1 1 0 01.11-.17l.12-.09.49-.29a.11.11 0 01.12 0 .17.17 0 010 .15 1.4 1.4 0 01-.09.4 3.14 3.14 0 01-.27.56 3.35 3.35 0 01-.44.59 2.19 2.19 0 01-.6.49 1 1 0 01-.63.18.67.67 0 01-.47-.25 1.43 1.43 0 01-.31-.63 4 4 0 01-.06-.92zm1.51-2.29a1.26 1.26 0 00-.31.25 2.39 2.39 0 00-.21.34 1.55 1.55 0 00-.13.36 2.33 2.33 0 00-.06.33l1.39-.8a1.28 1.28 0 00-.05-.27.49.49 0 00-.11-.23.34.34 0 00-.2-.09.61.61 0 00-.32.11z"
            style={{
              WebkitTransformOrigin: 270.127,
              MsTransformOrigin: 270.127,
              transformOrigin: 270.127,
            }}
            id="elu1ge5tpmf2f"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 296.06,
              MsTransformOrigin: 296.06,
              transformOrigin: 296.06,
            }}
            id="elw3ounyde35"
            fill="#E0E0E0"
            d="M246.07 183.58L346.05 125.86 346.05 156.94 246.07 214.66 246.07 183.58z"
            className="animable"
          ></path>
        </g>
      </g>
      <g
        id="freepik--character-2--inject-66"
        className="animable"
        style={{
          WebkitTransformOrigin: 165.293,
          MsTransformOrigin: 165.293,
          transformOrigin: 165.293,
        }}
      >
        <g
          id="freepik--window--inject-66"
          className="animable"
          style={{
            WebkitTransformOrigin: 157.01,
            MsTransformOrigin: 157.01,
            transformOrigin: 157.01,
          }}
        >
          <path
            d="M211.45 68.42L95.71 135.15a5.77 5.77 0 00-2.6 4.51v257.09a5.72 5.72 0 002.61 4.5l1.63.93a5.76 5.76 0 005.21 0l115.74-66.85a5.76 5.76 0 002.61-4.51v-257a5.72 5.72 0 00-2.62-4.5l-1.62-.93a5.78 5.78 0 00-5.22.03z"
            style={{
              WebkitTransformOrigin: 157.01,
              MsTransformOrigin: 157.01,
              transformOrigin: 157.01,
            }}
            id="elg8ni207bam4"
            fill="#E0E0E0"
            className="animable"
          ></path>
          <path
            d="M220.91 331c0 2.29-1.61 3.75-3.61 4.89l-113.74 65.69c-2 1.15-3.6.22-3.6-2.08V144.71a7.16 7.16 0 013.58-6.21L217.3 72.79a2.41 2.41 0 013.61 2.08z"
            style={{
              WebkitTransformOrigin: 160.435,
              MsTransformOrigin: 160.435,
              transformOrigin: 160.435,
            }}
            id="elr318i50wvd7"
            fill="#FAFAFA"
            className="animable"
          ></path>
          <path
            d="M218.5 73.47a1.4 1.4 0 011.4 1.4V331c0 1.55-1 2.79-3.1 4l-113.74 65.71a2.28 2.28 0 01-1.11.36c-.86 0-1-1-1-1.57V144.71a6.19 6.19 0 013.08-5.34L217.8 73.66a1.37 1.37 0 01.7-.19m0-1a2.43 2.43 0 00-1.2.32L103.54 138.5a7.16 7.16 0 00-3.58 6.21V399.5c0 1.63.81 2.57 2 2.57a3.29 3.29 0 001.61-.49L217.3 335.9c2-1.14 3.61-2.6 3.61-4.89V74.87a2.41 2.41 0 00-2.41-2.4z"
            style={{
              WebkitTransformOrigin: 160.435,
              MsTransformOrigin: 160.435,
              transformOrigin: 160.435,
            }}
            id="elhcrklercxzi"
            fill="#E0E0E0"
            className="animable"
          ></path>
          <path
            d="M220.91 73.84v1a2.41 2.41 0 00-3.61-2.08l-113.76 65.75a7.06 7.06 0 00-2.62 2.61v.08l-7-4.06a5.36 5.36 0 011.88-2l115.65-66.72a5.81 5.81 0 015.22 0l1.62.93a5.73 5.73 0 012.62 4.49z"
            style={{
              WebkitTransformOrigin: 157.415,
              MsTransformOrigin: 157.415,
              transformOrigin: 157.415,
            }}
            id="elgyg92en96mg"
            fill="#F0F0F0"
            className="animable"
          ></path>
          <path
            d="M122.17 142.14a.32.32 0 010-.17v-.84l-1.31.76c-.08 0-.11 0-.11-.12v-.3a.86.86 0 010-.17.9.9 0 010-.16l1.39-3.81a1.13 1.13 0 01.07-.15.24.24 0 01.09-.08l.18-.11h.12v3.12l.29-.17h.12a.41.41 0 010 .19v.2a.58.58 0 010 .21.28.28 0 01-.12.12l-.29.17v.84a.41.41 0 010 .21.22.22 0 01-.12.13l-.22.13c-.02.02-.06.03-.09 0zm.06-1.78v-2.09l-1 2.64z"
            style={{
              WebkitTransformOrigin: 121.883,
              MsTransformOrigin: 121.883,
              transformOrigin: 121.883,
            }}
            id="elfm6y9bb96vr"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M123.73 140.73a2.81 2.81 0 01-.38-1.71 5.41 5.41 0 01.39-2.16 2.6 2.6 0 011.08-1.31 1.46 1.46 0 01.53-.2.56.56 0 01.41.06.08.08 0 010 .07.38.38 0 010 .1l-.12.44a.31.31 0 010 .09h-.06a.74.74 0 00-.67.1 1.9 1.9 0 00-.74.91 4.06 4.06 0 00-.27 1.59 2.27 2.27 0 00.26 1.3c.18.21.42.23.72.05a1.72 1.72 0 00.32-.23 1.66 1.66 0 00.26-.28v-1.37l-.55.32h-.11a.26.26 0 010-.18v-.19a.43.43 0 010-.22.25.25 0 01.11-.12l.88-.5h.13a.47.47 0 010 .22v1.94a.72.72 0 010 .17.24.24 0 010 .13 2.71 2.71 0 01-1 1c-.57.3-.92.25-1.19-.02z"
            style={{
              WebkitTransformOrigin: 124.635,
              MsTransformOrigin: 124.635,
              transformOrigin: 124.635,
            }}
            id="elng3szp7e8i"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M134.8 134a2 2 0 01-.76 1.61c-.42.25-.76-.08-.76-.73a2 2 0 01.76-1.61c.42-.22.76.11.76.73z"
            style={{
              WebkitTransformOrigin: 134.04,
              MsTransformOrigin: 134.04,
              transformOrigin: 134.04,
            }}
            id="el89inhb80mqf"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M134 131.38a4.57 4.57 0 00-1.77 2.66c-.07.24 0 .46.08.53.14.09.36-.09.44-.39a3.24 3.24 0 011.25-1.88.81.81 0 011.25.44c.08.2.3.14.44-.12a.77.77 0 00.08-.63 1.14 1.14 0 00-1.77-.61z"
            style={{
              WebkitTransformOrigin: 134.003,
              MsTransformOrigin: 134.003,
              transformOrigin: 134.003,
            }}
            id="elhc2t0gzkwic"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M134 129.5a7.12 7.12 0 00-2.72 3.87c-.09.25-.06.51.06.59.14.09.35-.09.44-.37a5.82 5.82 0 012.22-3.17 1.47 1.47 0 012.22.6c.1.18.3.12.44-.13a.75.75 0 00.06-.66 1.81 1.81 0 00-2.72-.73z"
            style={{
              WebkitTransformOrigin: 133.999,
              MsTransformOrigin: 133.999,
              transformOrigin: 133.999,
            }}
            id="elt4bo9yoh64s"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M159.85 117.16a.08.08 0 01.1 0 .21.21 0 010 .12v.76a.58.58 0 010 .18.27.27 0 01-.1.11l-.47.27a.07.07 0 01-.09 0 .17.17 0 010-.13v-.76a.35.35 0 010-.17.29.29 0 01.09-.12zm0 2.72a.08.08 0 01.1 0 .17.17 0 010 .12v.76a.47.47 0 010 .17.25.25 0 01-.1.12l-.47.27a.06.06 0 01-.09 0v-.88a.35.35 0 010-.17.24.24 0 01.09-.12z"
            style={{
              WebkitTransformOrigin: 159.619,
              MsTransformOrigin: 159.619,
              transformOrigin: 159.619,
            }}
            id="el4z9eqzhmq4s"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M162.54 119.51a.08.08 0 01-.09 0 .17.17 0 010-.13v-.94l-1.56.91a.08.08 0 01-.1 0 .16.16 0 010-.12v-.55a.66.66 0 010-.21c0-.07 0-.14.08-.22l1.54-3.86a.63.63 0 01.21-.31l.38-.22a.08.08 0 01.1 0 .17.17 0 010 .13v3.1l.43-.25a.08.08 0 01.1 0 .15.15 0 010 .12v.55a.33.33 0 010 .17.25.25 0 01-.1.12l-.43.25v.95a.33.33 0 010 .17.25.25 0 01-.1.12zm-.13-2.05v-1.66l-.86 2.16z"
            style={{
              WebkitTransformOrigin: 162.21,
              MsTransformOrigin: 162.21,
              transformOrigin: 162.21,
            }}
            id="elugs0fl6pyj"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M157.37 122.47a.08.08 0 01-.1 0 .22.22 0 010-.13v-.94l-1.56.91a.08.08 0 01-.1 0 .21.21 0 010-.12v-.56a.45.45 0 010-.2 1.87 1.87 0 01.07-.22l1.55-3.86a.57.57 0 01.2-.31l.39-.23a.07.07 0 01.09 0 .17.17 0 010 .13V120l.44-.25a.06.06 0 01.09 0v.67a.33.33 0 010 .17.24.24 0 01-.09.12l-.44.25V122a.35.35 0 010 .17.24.24 0 01-.09.12zm-.14-2v-1.66l-.86 2.16z"
            style={{
              WebkitTransformOrigin: 157.025,
              MsTransformOrigin: 157.025,
              transformOrigin: 157.025,
            }}
            id="elugh1knvkdar"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M164.57 113.11a.35.35 0 010-.17.25.25 0 01.1-.12l1.89-1.09a.09.09 0 01.1 0 .22.22 0 010 .13v.55a.53.53 0 010 .17.25.25 0 01-.1.12l-1.41.82-.06 1a1.23 1.23 0 01.27-.25l.22-.15a1.2 1.2 0 01.52-.18.6.6 0 01.42.1.87.87 0 01.28.4 2.06 2.06 0 01.1.71 3.62 3.62 0 01-.1.91 3.17 3.17 0 01-.29.75 2.21 2.21 0 01-.42.58 2.72 2.72 0 01-.51.4 1.64 1.64 0 01-.6.22.62.62 0 01-.41-.1.77.77 0 01-.25-.35 1.61 1.61 0 01-.09-.52.25.25 0 010-.17.24.24 0 01.09-.12l.41-.24h.09a.15.15 0 01.06.11.55.55 0 00.09.23.29.29 0 00.16.09.33.33 0 00.19 0 1.38 1.38 0 00.22-.1 1.15 1.15 0 00.46-.51 1.61 1.61 0 00.18-.76.54.54 0 00-.18-.48.41.41 0 00-.46 0 1.25 1.25 0 00-.24.18.67.67 0 00-.14.16l-.1.14a.38.38 0 01-.12.1l-.46.27a.08.08 0 01-.1 0v-.12z"
            style={{
              WebkitTransformOrigin: 165.558,
              MsTransformOrigin: 165.558,
              transformOrigin: 165.558,
            }}
            id="elj0znz57fw4b"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 108.37,
              MsTransformOrigin: 108.37,
              transformOrigin: 108.37,
            }}
            id="eleq3dk4xpl0v"
            fill="#455A64"
            d="M107.67 151.14L107.67 149.52 109.07 148.71 109.07 150.33 107.67 151.14z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 110.47,
              MsTransformOrigin: 110.47,
              transformOrigin: 110.47,
            }}
            id="elqs6y9w4724"
            fill="#455A64"
            d="M109.77 149.93L109.77 146.69 111.17 145.88 111.17 149.12 109.77 149.93z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 112.57,
              MsTransformOrigin: 112.57,
              transformOrigin: 112.57,
            }}
            id="el0eehtgpctt"
            fill="#455A64"
            d="M111.87 148.71L111.87 143.86 113.27 143.05 113.27 147.9 111.87 148.71z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 114.675,
              MsTransformOrigin: 114.675,
              transformOrigin: 114.675,
            }}
            id="elet4yvbm8plk"
            fill="#455A64"
            d="M113.97 147.5L113.97 141.03 115.38 140.22 115.38 146.69 113.97 147.5z"
            className="animable"
          ></path>
          <path
            d="M212.4 85.42a.37.37 0 00-.52-.17l-5.24 3a2 2 0 00-.6 1.59v2.94a1.67 1.67 0 00.23.94.42.42 0 00.21.19.31.31 0 00.31 0l5.23-3a2 2 0 00.6-1.59v-2.96a1.79 1.79 0 00-.22-.94zm-6 7.93a.83.83 0 01-.09-.43V90a1.57 1.57 0 01.47-1.21l5.23-3a.21.21 0 01.17 0 .17.17 0 01.06.06.79.79 0 01.09.43v2.94a1.57 1.57 0 01-.46 1.21l-5.24 3a.15.15 0 01-.22-.08z"
            style={{
              WebkitTransformOrigin: 209.33,
              MsTransformOrigin: 209.33,
              transformOrigin: 209.33,
            }}
            id="eloma01u2w0nk"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M207.78 88.71v3.48l-.82.47a.11.11 0 01-.16-.09V90a1.21 1.21 0 01.34-.9z"
            style={{
              WebkitTransformOrigin: 207.289,
              MsTransformOrigin: 207.289,
              transformOrigin: 207.289,
            }}
            id="elnz525tcr7pa"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 208.65,
              MsTransformOrigin: 208.65,
              transformOrigin: 208.65,
            }}
            id="elwdfr4plamlc"
            fill="#455A64"
            d="M208.16 88.5L209.14 87.93 209.14 91.41 208.16 91.97 208.16 88.5z"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 210.015,
              MsTransformOrigin: 210.015,
              transformOrigin: 210.015,
            }}
            id="elt2mjdvfdexj"
            fill="#455A64"
            d="M209.52 87.72L210.51 87.14 210.51 90.63 209.52 91.2 209.52 87.72z"
            className="animable"
          ></path>
          <path
            d="M211.87 86.59v2.51a1.3 1.3 0 01-.65 1.12l-.33.19v-3.48l.78-.45a.13.13 0 01.2.11z"
            style={{
              WebkitTransformOrigin: 211.38,
              MsTransformOrigin: 211.38,
              transformOrigin: 211.38,
            }}
            id="el3r8cpmfi77f"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M212.82 86.27c.14-.09.26.33.26.93v.55a2.24 2.24 0 01-.26 1.27l-.27.18v-2.78z"
            style={{
              WebkitTransformOrigin: 212.82,
              MsTransformOrigin: 212.82,
              transformOrigin: 212.82,
            }}
            id="el7hmu3w79njx"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 200.635,
              MsTransformOrigin: 200.635,
              transformOrigin: 200.635,
            }}
            id="elhug45awol5p"
            fill="#455A64"
            d="M198.09 95.16L203.18 90.64 201.61 97.26 200.87 94.51 198.09 95.16z"
            className="animable"
          ></path>
          <path
            d="M110.1 158l81.9-47.26c1.36-.78 2.46-.14 2.46 1.42v7.65a5.45 5.45 0 01-2.46 4.26l-81.9 47.28c-1.36.78-2.46.15-2.46-1.42v-7.64a5.42 5.42 0 012.46-4.29z"
            style={{
              WebkitTransformOrigin: 151.05,
              MsTransformOrigin: 151.05,
              transformOrigin: 151.05,
            }}
            id="el50e0ymmt2ml"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M200.64 118.1a.94.94 0 01-.82-.47.93.93 0 01.34-1.29L211 110a1 1 0 011 1.64L201.11 118a.9.9 0 01-.47.1z"
            style={{
              WebkitTransformOrigin: 205.974,
              MsTransformOrigin: 205.974,
              transformOrigin: 205.974,
            }}
            id="eljt83pduvflg"
            fill="#E0E0E0"
            className="animable"
          ></path>
          <path
            d="M200.64 113.43a.94.94 0 01-.48-1.76l10.84-6.32a.95.95 0 111 1.63l-10.83 6.32a.9.9 0 01-.53.13z"
            style={{
              WebkitTransformOrigin: 206.069,
              MsTransformOrigin: 206.069,
              transformOrigin: 206.069,
            }}
            id="elv7ztnwml7ij"
            fill="#E0E0E0"
            className="animable"
          ></path>
          <path
            d="M200.64 108.77a1 1 0 01-.48-1.77l10.84-6.32a1 1 0 011.3.34.94.94 0 01-.34 1.29l-10.83 6.33a1 1 0 01-.49.13z"
            style={{
              WebkitTransformOrigin: 206.107,
              MsTransformOrigin: 206.107,
              transformOrigin: 206.107,
            }}
            id="el9remog3xjim"
            fill="#E0E0E0"
            className="animable"
          ></path>
        </g>
        <g
          id="freepik--Character--inject-66"
          className="animable"
          style={{
            WebkitTransformOrigin: 168.718,
            MsTransformOrigin: 168.718,
            transformOrigin: 168.718,
          }}
        >
          <g
            id="freepik--Botom--inject-66"
            className="animable"
            style={{
              WebkitTransformOrigin: 134.07,
              MsTransformOrigin: 134.07,
              transformOrigin: 134.07,
            }}
          >
            <path
              d="M100 344.75v54.85c0 2.21 1.56 3.1 3.46 2l34.31-19.81 3.33-1.92 26.49-15.3c.15-5 .28-9.22.37-12.33.12-3.59.18-5.68.18-5.68z"
              style={{
                WebkitTransformOrigin: 134.07,
                MsTransformOrigin: 134.07,
                transformOrigin: 134.07,
              }}
              id="elg4dqcc3z5o"
              fill="#455A64"
              className="animable"
            ></path>
          </g>
          <g
            id="freepik--Top--inject-66"
            className="animable"
            style={{
              WebkitTransformOrigin: 168.718,
              MsTransformOrigin: 168.718,
              transformOrigin: 168.718,
            }}
          >
            <path
              d="M206.5 271.07a27.12 27.12 0 00.58-4.22c.56-6.82 4.09-12.87 7.88-18.41.64-.94 1.3-1.88 2-2.82a13.92 13.92 0 00.92-1.39c.24-.47.46-.85 1.12-.72a1.88 1.88 0 011.1.82 5.56 5.56 0 01.67 4.48 26.65 26.65 0 01-1.63 4.36c-.46 1.11.86.77 1.46.52 2.94-1.23 5.89-5.34 7.74-7.87 1.21-1.66 2.11-3.53 3.57-5a6.26 6.26 0 013.27-1.87c.85-.15 1.68 0 1.77 1.08a4.36 4.36 0 01-.52 1.93c-.52 1.28-1 2.44-.4 3.8a10.81 10.81 0 011 2.57c.17 1.17-.36 2.33-.33 3.51s.63 1.92.76 2.91-.54 2.52-.9 3.5a28.46 28.46 0 01-3.52 6.54 54.31 54.31 0 01-7.63 8.34 14.92 14.92 0 00-4 4.81 31.67 31.67 0 00-1.69 6.08c-.54 2.58-1 5.18-1.57 7.76-5.74 28-8.61 29.55-12.25 33.72-2.2 2.52-8.55 4.9-17.18-4-9.58-9.9-27.9-35.5-27.9-35.5L157 251.79s3.41.92 7.72 2.15c4 1.15 8.26 5.19 11.12 9.71C181.75 273 197 297.34 197 297.34s8.34-22.63 9.5-26.27z"
              style={{
                WebkitTransformOrigin: 197.238,
                MsTransformOrigin: 197.238,
                transformOrigin: 197.238,
              }}
              id="el2in2bl5dm1h"
              fill="#FFBDA7"
              className="animable"
            ></path>
            <path
              d="M159.72 252.11c6.32.84 10 2.8 13.73 7.18s18.05 28.28 18.05 28.28-4.88 10.52-18.05 16.07l-16.37-21.46z"
              style={{
                WebkitTransformOrigin: 174.29,
                MsTransformOrigin: 174.29,
                transformOrigin: 174.29,
              }}
              id="ele9t1g82yd7o"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M159.72 252.11c6.32.84 10 2.8 13.73 7.18s18.05 28.28 18.05 28.28-4.88 10.52-18.05 16.07l-16.37-21.46z"
              style={{
                WebkitTransformOrigin: 174.29,
                MsTransformOrigin: 174.29,
                transformOrigin: 174.29,
              }}
              id="elyrpg5ph1fbn"
              className="animable"
              opacity="0.15"
            ></path>
            <path
              d="M197 297.34a53.79 53.79 0 00-4.33 15.29S190.85 302 195 294.1z"
              style={{
                WebkitTransformOrigin: 194.636,
                MsTransformOrigin: 194.636,
                transformOrigin: 194.636,
              }}
              id="el4tvviecwesx"
              fill="#F0997A"
              className="animable"
            ></path>
            <path
              d="M218.61 257.85c.39 3.85-1.2 9.15-2.61 11.15a12.07 12.07 0 003.21-5.3c.69-3.2.19-4.61-.6-5.85z"
              style={{
                WebkitTransformOrigin: 217.768,
                MsTransformOrigin: 217.768,
                transformOrigin: 217.768,
              }}
              id="elpuolhedsyta"
              fill="#F0997A"
              className="animable"
            ></path>
            <path
              d="M169.25 352.51c-13.24 9.4-56.59 12.54-69.29 4.14V255.11l1-.2 12.43-2.62 6.73-1.42 1.71-.36 6-1.26 15.64.91 4.71.28h.46s5.44.65 11.09 1.63c.21.19.4.39.61.6 3.92 4.23 7.3 15 8.26 26.53.36 4.39.62 11 .82 18.41v.69c.58 22.7-.17 54.21-.17 54.21z"
              style={{
                WebkitTransformOrigin: 134.8,
                MsTransformOrigin: 134.8,
                transformOrigin: 134.8,
              }}
              id="el9devrw7juza"
              fill="#8AC832"
              className="animable"
            ></path>
            <g
              id="freepik--Head--inject-66"
              className="animable"
              style={{
                WebkitTransformOrigin: 134.212,
                MsTransformOrigin: 134.212,
                transformOrigin: 134.212,
              }}
            >
              <path
                d="M159.09 211.79c2.77-6.36.06-14.8-3.26-18.76-4.79-5.73-12.24-8.2-23.48-7.5-8.55.53-16.95 4.08-18.55 12.85-6.87 2.05-6.09 13.33-4.38 18.31 3.47 10.09 10.29 18.88 10.4 24z"
                style={{
                  WebkitTransformOrigin: 134.239,
                  MsTransformOrigin: 134.239,
                  transformOrigin: 134.239,
                }}
                id="eljb9kdx3ovt"
                fill="#455A64"
                className="animable"
              ></path>
              <path
                d="M159.08 235.54c-1.35 4.88-4.17 8.45-8.68 9.15a37.43 37.43 0 01-7.11 0l.17 6.21c6.07 5.19 3.85 12-.2 18.16-5-5.59-10.78-7.59-15.81-9.8a16.1 16.1 0 01-7.33-7.1l-.64-21s-2.76 3.14-7.31.17a9.92 9.92 0 01-3.08-12.14c2.25-4.76 6.76-2.79 8.15-1.35s3 4.16 4.17 3.78a4.17 4.17 0 002.79-2.85 25.49 25.49 0 001.48-9.22 12.59 12.59 0 003.53-2.72 11.47 11.47 0 003.06-7.06c9.74-3 20.95-1.61 25 1.52 2.33 4.11 2.41 13.65 2.8 19.15.42 6.05.15 11.02-.99 15.1z"
                style={{
                  WebkitTransformOrigin: 134.212,
                  MsTransformOrigin: 134.212,
                  transformOrigin: 134.212,
                }}
                id="elwgrw9lpm0r"
                fill="#FFBDA7"
                className="animable"
              ></path>
              <path
                d="M143.28 244.73c-5-.28-15-2.61-17.68-5.39s-3.81-8.48-3.81-8.48.4 7.19 2.47 10.36 7.28 4.56 10.45 5.35a76.62 76.62 0 008.67 1.31z"
                style={{
                  WebkitTransformOrigin: 132.585,
                  MsTransformOrigin: 132.585,
                  transformOrigin: 132.585,
                }}
                id="el4n9zz4vmgi5"
                fill="#F0997A"
                className="animable"
              ></path>
              <path
                d="M143.26 269.1c-2.61-1.6-8.37-8.14-11.24-5.1s-4.39 3.87-6.29 3.31-6.06-4.69-8.79-7.7a17.45 17.45 0 01-3.6-7.35 47.47 47.47 0 003.85-5.35c1.3-2.3 1-2.95 2.68-3.06l.15 4.34s1 2.37 5.74 5.57 14.13 7.96 17.5 15.34z"
                style={{
                  WebkitTransformOrigin: 128.3,
                  MsTransformOrigin: 128.3,
                  transformOrigin: 128.3,
                }}
                id="elcpt7x3pxqbu"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M143.26 269.1c-2.61-1.6-8.37-8.14-11.24-5.1s-4.39 3.87-6.29 3.31-6.06-4.69-8.79-7.7a17.45 17.45 0 01-3.6-7.35 47.47 47.47 0 003.85-5.35c1.3-2.3 1-2.95 2.68-3.06l.15 4.34s1 2.37 5.74 5.57 14.13 7.96 17.5 15.34z"
                style={{
                  WebkitTransformOrigin: 128.3,
                  MsTransformOrigin: 128.3,
                  transformOrigin: 128.3,
                }}
                id="elzsbkvoyddd"
                className="animable"
                opacity="0.15"
              ></path>
              <path
                d="M143.26 269.1c1.55-1.42 4.08-8 4.75-7.84 1 .29 2.78 4.85 3.64 3.79 1.36-1.68.95-9.36-1.32-12.15s-5.29-5.76-7-6.05l.12 4.09a16.58 16.58 0 011.68 6.6c0 2.33-1.55 9.33-1.87 11.56z"
                style={{
                  WebkitTransformOrigin: 147.844,
                  MsTransformOrigin: 147.844,
                  transformOrigin: 147.844,
                }}
                id="el6uymi9kvqtw"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M143.26 269.1c1.55-1.42 4.08-8 4.75-7.84 1 .29 2.78 4.85 3.64 3.79 1.36-1.68.95-9.36-1.32-12.15s-5.29-5.76-7-6.05l.12 4.09a16.58 16.58 0 011.68 6.6c0 2.33-1.55 9.33-1.87 11.56z"
                style={{
                  WebkitTransformOrigin: 147.844,
                  MsTransformOrigin: 147.844,
                  transformOrigin: 147.844,
                }}
                id="elux66rs0kadl"
                className="animable"
                opacity="0.15"
              ></path>
              <path
                d="M140.13 217.33a2 2 0 01-2 2.09 2.1 2.1 0 112-2.09z"
                style={{
                  WebkitTransformOrigin: 138.031,
                  MsTransformOrigin: 138.031,
                  transformOrigin: 138.031,
                }}
                id="eltp2r55n7ak"
                fill="#263238"
                className="animable"
              ></path>
              <path
                d="M137.31 210.88l-4.08 2.76a2.59 2.59 0 01.69-3.51 2.41 2.41 0 013.39.75z"
                style={{
                  WebkitTransformOrigin: 135.067,
                  MsTransformOrigin: 135.067,
                  transformOrigin: 135.067,
                }}
                id="elmvf6r2xwess"
                fill="#37474F"
                className="animable"
              ></path>
              <path
                d="M156.87 212.77l-4.48-2.14a2.38 2.38 0 013.24-1.22 2.6 2.6 0 011.24 3.36z"
                style={{
                  WebkitTransformOrigin: 154.736,
                  MsTransformOrigin: 154.736,
                  transformOrigin: 154.736,
                }}
                id="el286bhro8v61"
                fill="#37474F"
                className="animable"
              ></path>
              <path
                d="M155.36 217.2a2 2 0 01-2 2.1 2.1 2.1 0 112-2.1z"
                style={{
                  WebkitTransformOrigin: 153.261,
                  MsTransformOrigin: 153.261,
                  transformOrigin: 153.261,
                }}
                id="eliuzzchf7ojn"
                fill="#263238"
                className="animable"
              ></path>
              <path
                style={{
                  WebkitTransformOrigin: 149.38,
                  MsTransformOrigin: 149.38,
                  transformOrigin: 149.38,
                }}
                id="el5feek4auzis"
                fill="#F0997A"
                d="M144.76 212.99L146.22 227.49 154 225.14 144.76 212.99z"
                className="animable"
              ></path>
              <path
                d="M140.12 230.86l8.34 1.85a4.2 4.2 0 01-5 3.39 4.48 4.48 0 01-3.34-5.24z"
                style={{
                  WebkitTransformOrigin: 144.246,
                  MsTransformOrigin: 144.246,
                  transformOrigin: 144.246,
                }}
                id="elwf1wywhobqi"
                fill="#B16668"
                className="animable"
              ></path>
              <path
                d="M143.46 236.1c.17 0 .34 0 .52.06a3.89 3.89 0 00-3.88-3.79 4.43 4.43 0 003.36 3.73z"
                style={{
                  WebkitTransformOrigin: 142.04,
                  MsTransformOrigin: 142.04,
                  transformOrigin: 142.04,
                }}
                id="el8775w9m7ydh"
                fill="#F28F8F"
                className="animable"
              ></path>
            </g>
            <path
              d="M103 288.1l-3 7.38v-40.37s8.62 16.58 3 32.99z"
              style={{
                WebkitTransformOrigin: 102.451,
                MsTransformOrigin: 102.451,
                transformOrigin: 102.451,
              }}
              id="elji53eog39f"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M103 288.1l-3 7.38v-40.37s8.62 16.58 3 32.99z"
              style={{
                WebkitTransformOrigin: 102.451,
                MsTransformOrigin: 102.451,
                transformOrigin: 102.451,
              }}
              id="elfzp2nv5hvuw"
              className="animable"
              opacity="0.15"
            ></path>
          </g>
          <path
            d="M160.27 224.73a24.92 24.92 0 015.4 2.51 4.76 4.76 0 011.66 6.46l-2.06-.4s1.06-2.41-.18-3.71-4.85-2.4-4.85-2.4z"
            style={{
              WebkitTransformOrigin: 164.105,
              MsTransformOrigin: 164.105,
              transformOrigin: 164.105,
            }}
            id="el4if1s5r302t"
            fill="#263238"
            className="animable"
          ></path>
          <path
            d="M166.47 232.37c-1.67-.81-2.47.23-3.65 3.06s-.37 3.61 1.06 4.17 2.54-.38 3.42-2.72c.99-2.64.97-3.64-.83-4.51z"
            style={{
              WebkitTransformOrigin: 165.104,
              MsTransformOrigin: 165.104,
              transformOrigin: 165.104,
            }}
            id="elefcnslcaxi"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M166.47 232.37c-1.67-.81-2.47.23-3.65 3.06s-.37 3.61 1.06 4.17 2.54-.38 3.42-2.72c.99-2.64.97-3.64-.83-4.51z"
            style={{
              WebkitTransformOrigin: 165.104,
              MsTransformOrigin: 165.104,
              transformOrigin: 165.104,
            }}
            id="elninicppf65k"
            className="animable"
            opacity="0.1"
          ></path>
          <path
            d="M118.09 189c-5 4.61-9.77 11.16-6.22 26.31a8.25 8.25 0 00-2.07 8.55c1.38 4.68 5.87 7.75 10 6.87s6.44-5.39 5.07-10.07c-1-3.5-4.78-6.89-7.87-6.66 0 0-3-6.49-.19-15.66 3.79-12.52 18.37-13.55 24.79-12.54-2.12-3.05-16.93-2.87-23.51 3.2z"
            style={{
              WebkitTransformOrigin: 125.484,
              MsTransformOrigin: 125.484,
              transformOrigin: 125.484,
            }}
            id="elu9ec0sde2t"
            fill="#263238"
            className="animable"
          ></path>
          <path
            d="M125.8 220.47c-1.52-5.19-6.5-8.6-11.12-7.62a7.24 7.24 0 00-2 .75c-.51.28-2.09 1.37-2.4 1.57-2.94 2-4.3 6-3.09 10.1 1.52 5.19 6.49 8.6 11.11 7.62a7.33 7.33 0 002.39-1c.37-.24 1.84-1.22 2.21-1.48 2.8-1.96 4.1-5.89 2.9-9.94z"
            style={{
              WebkitTransformOrigin: 116.498,
              MsTransformOrigin: 116.498,
              transformOrigin: 116.498,
            }}
            id="elfjv0zmx8ghc"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M125.8 220.47c-1.52-5.19-6.5-8.6-11.12-7.62a7.24 7.24 0 00-2 .75c-.51.28-2.09 1.37-2.4 1.57-2.94 2-4.3 6-3.09 10.1 1.52 5.19 6.49 8.6 11.11 7.62a7.33 7.33 0 002.39-1c.37-.24 1.84-1.22 2.21-1.48 2.8-1.96 4.1-5.89 2.9-9.94z"
            style={{
              WebkitTransformOrigin: 116.498,
              MsTransformOrigin: 116.498,
              transformOrigin: 116.498,
            }}
            id="el6tqfaxfu78o"
            className="animable"
            opacity="0.3"
          ></path>
          <path
            d="M123.91 221.73c-1.52-5.18-6.5-8.59-11.12-7.61s-7.13 6-5.61 11.15 6.49 8.6 11.11 7.62 7.14-5.97 5.62-11.16z"
            style={{
              WebkitTransformOrigin: 115.544,
              MsTransformOrigin: 115.544,
              transformOrigin: 115.544,
            }}
            id="ely6va4qb60r"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M123.91 221.73c-1.52-5.18-6.5-8.59-11.12-7.61s-7.13 6-5.61 11.15 6.49 8.6 11.11 7.62 7.14-5.97 5.62-11.16z"
            style={{
              WebkitTransformOrigin: 115.544,
              MsTransformOrigin: 115.544,
              transformOrigin: 115.544,
            }}
            id="el01kc1gearrav"
            className="animable"
            opacity="0.1"
          ></path>
          <path
            d="M119.49 222.67c-.72-2.45-3.06-4.06-5.24-3.6s-3.37 2.82-2.65 5.27 3.06 4 5.24 3.59 3.37-2.82 2.65-5.26z"
            style={{
              WebkitTransformOrigin: 115.545,
              MsTransformOrigin: 115.545,
              transformOrigin: 115.545,
            }}
            id="elkbeakxamdr"
            fill="#37474F"
            className="animable"
          ></path>
        </g>
        <g
          id="freepik--speech-bubble--inject-66"
          className="animable"
          style={{
            WebkitTransformOrigin: 188.37,
            MsTransformOrigin: 188.37,
            transformOrigin: 188.37,
          }}
        >
          <path
            d="M177.27 165.06a2.1 2.1 0 00-.58.48 2.79 2.79 0 00-.38.62 3.81 3.81 0 00-.22.7c0 .24-.08.49-.1.74s0 .34 0 .58v2.04a3.74 3.74 0 00.1.64 1.21 1.21 0 00.22.44.55.55 0 00.39.18 1 1 0 00.57-.18 2.54 2.54 0 00.5-.38 2.63 2.63 0 00.4-.53 2.85 2.85 0 00.28-.69 3.76 3.76 0 00.1-.86l-.85.49a.15.15 0 01-.2 0 .34.34 0 01-.08-.25v-1.65a.89.89 0 01.08-.35.51.51 0 01.2-.23l2.45-1.42a.15.15 0 01.19 0 .34.34 0 01.08.25v2a7.81 7.81 0 01-.24 1.94 8 8 0 01-.67 1.73 6.76 6.76 0 01-1 1.43 5.1 5.1 0 01-1.24 1 2.69 2.69 0 01-1.3.42 1.47 1.47 0 01-1-.35 2.13 2.13 0 01-.62-1 5.1 5.1 0 01-.25-1.49V170v-1.41a7.84 7.84 0 01.24-1.77 8.33 8.33 0 01.63-1.71 7 7 0 011-1.48 5.21 5.21 0 011.31-1.09 2.64 2.64 0 011.28-.41 1.57 1.57 0 011 .25 1.82 1.82 0 01.62.72 2.31 2.31 0 01.24 1 .48.48 0 01-.06.28.48.48 0 01-.16.2l-1.35.77q-.15.09-.24 0l-.16-.18a.81.81 0 00-.39-.29c-.21-.08-.46-.01-.79.18z"
            style={{
              WebkitTransformOrigin: 177.261,
              MsTransformOrigin: 177.261,
              transformOrigin: 177.261,
            }}
            id="eld1vmztyp4l"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M183 167.15a1.28 1.28 0 00.08.54.5.5 0 00.22.25.41.41 0 00.29 0 1 1 0 00.32-.12 2.16 2.16 0 00.48-.37 1.9 1.9 0 00.3-.44 1.86 1.86 0 01.16-.27.41.41 0 01.17-.14l1.32-.76c.15-.09.22 0 .22.21a2.53 2.53 0 01-.15.66 6.6 6.6 0 01-1.3 2.22 4.63 4.63 0 01-1.2 1 2.37 2.37 0 01-1.17.39 1.13 1.13 0 01-.86-.34 2.14 2.14 0 01-.53-1 6.52 6.52 0 01-.18-1.66 8.81 8.81 0 01.18-1.78 7.32 7.32 0 01.53-1.64 6.21 6.21 0 01.86-1.37 4.27 4.27 0 011.17-1 2.05 2.05 0 011.26-.35 1.32 1.32 0 01.85.5 2.74 2.74 0 01.48 1.09 7.27 7.27 0 01.14 1.42v.44a.68.68 0 01-.08.34.48.48 0 01-.19.24zm.91-3.52a1.53 1.53 0 00-.65.76 3.06 3.06 0 00-.26 1l1.82-1.06a1.37 1.37 0 00-.26-.72c-.12-.14-.34-.15-.62.02z"
            style={{
              WebkitTransformOrigin: 183.904,
              MsTransformOrigin: 183.904,
              transformOrigin: 183.904,
            }}
            id="elznlawfk5p6c"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M190 163.13a.86.86 0 00.11.5c.06.09.18.09.33 0l.81-.47a.15.15 0 01.19 0 .3.3 0 01.08.25V165a.74.74 0 01-.08.35.5.5 0 01-.19.23l-1 .56a2 2 0 01-.87.29.91.91 0 01-.66-.23 1.66 1.66 0 01-.43-.72 4.08 4.08 0 01-.15-1.2v-2.62l-.75.43a.14.14 0 01-.19 0 .34.34 0 01-.08-.25v-1.57a.89.89 0 01.08-.35.5.5 0 01.19-.23l.75-.44v-2.55a.84.84 0 01.08-.34.61.61 0 01.19-.24l1.28-.73a.14.14 0 01.19 0 .3.3 0 01.08.25v2.54l1.15-.66a.15.15 0 01.19 0 .33.33 0 01.08.25v1.58a.71.71 0 01-.08.34.53.53 0 01-.19.24l-1.15.66z"
            style={{
              WebkitTransformOrigin: 189.321,
              MsTransformOrigin: 189.321,
              transformOrigin: 189.321,
            }}
            id="el4xq1vvn1cuf"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M196.33 153.24a.89.89 0 01-.08.35.51.51 0 01-.2.23l-1.27.74a.16.16 0 01-.2 0 .37.37 0 01-.08-.25v-1.58a.84.84 0 01.08-.34.55.55 0 01.2-.24l1.27-.73a.15.15 0 01.2 0 .34.34 0 01.08.25zm0 9a.89.89 0 01-.08.35.51.51 0 01-.2.23l-1.27.74a.16.16 0 01-.2 0 .37.37 0 01-.08-.25V156a.89.89 0 01.08-.35.51.51 0 01.2-.23l1.27-.74a.16.16 0 01.2 0 .37.37 0 01.08.25z"
            style={{
              WebkitTransformOrigin: 195.415,
              MsTransformOrigin: 195.415,
              transformOrigin: 195.415,
            }}
            id="el669loo7e78d"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M202.9 158.42a.71.71 0 01-.08.34.6.6 0 01-.19.24l-1.28.73a.14.14 0 01-.19 0 .3.3 0 01-.08-.25v-3.95a1.65 1.65 0 00-.21-1c-.15-.19-.37-.2-.67 0a1.54 1.54 0 00-.67.79 3.21 3.21 0 00-.2 1.2v3.94a.76.76 0 01-.09.35.45.45 0 01-.19.23l-1.27.74a.15.15 0 01-.2 0 .34.34 0 01-.08-.25v-7.26a.89.89 0 01.08-.35.51.51 0 01.2-.23L199 153h.19a.33.33 0 01.09.25v.36c.05-.13.12-.28.2-.44a4.09 4.09 0 01.29-.48 5.39 5.39 0 01.4-.45 3.16 3.16 0 01.53-.39 2 2 0 01.9-.3.87.87 0 01.69.24 1.89 1.89 0 01.45.85 5.58 5.58 0 01.16 1.5z"
            style={{
              WebkitTransformOrigin: 200.201,
              MsTransformOrigin: 200.201,
              transformOrigin: 200.201,
            }}
            id="el6r73j6e1llg"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M175 187.55a.87.87 0 00.1.5c.07.09.18.09.34 0l.81-.47a.15.15 0 01.19 0 .37.37 0 01.08.25v1.58a.84.84 0 01-.08.34.48.48 0 01-.19.24l-1 .55a1.69 1.69 0 01-.86.29.9.9 0 01-.66-.22 1.49 1.49 0 01-.43-.72 4.08 4.08 0 01-.15-1.2v-2.62l-.75.43h-.19a.33.33 0 01-.09-.25v-1.58a.72.72 0 01.09-.34.48.48 0 01.19-.24l.75-.43v-2.54a.74.74 0 01.08-.35.5.5 0 01.19-.23l1.28-.74a.14.14 0 01.19 0 .33.33 0 01.08.24v2.55l1.15-.66a.14.14 0 01.19 0 .36.36 0 01.08.25v1.57a.89.89 0 01-.08.35.57.57 0 01-.19.23L175 185z"
            style={{
              WebkitTransformOrigin: 174.32,
              MsTransformOrigin: 174.32,
              transformOrigin: 174.32,
            }}
            id="el7x416mteliq"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M182.65 181.64v1.2a6.89 6.89 0 01-.22 1.54 7.35 7.35 0 01-.56 1.46 5.91 5.91 0 01-.86 1.27 4.43 4.43 0 01-1.11.93 2.31 2.31 0 01-1.13.36 1.22 1.22 0 01-.85-.28 1.87 1.87 0 01-.56-.82 4 4 0 01-.22-1.28v-.59-.61a6.7 6.7 0 01.21-1.52 7.21 7.21 0 01.56-1.47 6.37 6.37 0 01.86-1.28 4.36 4.36 0 011.13-.94 2.33 2.33 0 011.11-.35 1.35 1.35 0 01.87.28 1.85 1.85 0 01.55.82 4 4 0 01.22 1.28zm-3.65 3.25a1 1 0 00.28.77c.17.13.38.12.66 0a1.8 1.8 0 00.65-.71 2.74 2.74 0 00.28-1.09v-.54-.52a1 1 0 00-.28-.77.56.56 0 00-.65 0 1.75 1.75 0 00-.66.71 2.74 2.74 0 00-.28 1.09v1.06z"
            style={{
              WebkitTransformOrigin: 179.895,
              MsTransformOrigin: 179.895,
              transformOrigin: 179.895,
            }}
            id="elpuzr0beab1"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M183.55 178.08a.84.84 0 01.08-.34.49.49 0 01.2-.24l1.27-.74a.15.15 0 01.19 0 .3.3 0 01.09.25V181a1.84 1.84 0 00.19 1c.13.19.34.21.64 0a1.49 1.49 0 00.63-.78A3.52 3.52 0 00187 180v-4a.73.73 0 01.08-.34.6.6 0 01.19-.24l1.28-.73a.14.14 0 01.19 0 .36.36 0 01.08.25v7.27a.84.84 0 01-.08.34.48.48 0 01-.19.24l-1.18.68a.14.14 0 01-.19 0 .34.34 0 01-.08-.25v-.35c-.06.14-.12.29-.2.44a3 3 0 01-.29.47 4 4 0 01-.4.45 3.44 3.44 0 01-.54.4c-.65.37-1.18.39-1.56 0a3.27 3.27 0 01-.59-2.36z"
            style={{
              WebkitTransformOrigin: 186.155,
              MsTransformOrigin: 186.155,
              transformOrigin: 186.155,
            }}
            id="eldgkqhbcqrit"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M191.64 176.5a4.79 4.79 0 000 .56 4.19 4.19 0 000 .53 1 1 0 00.27.75c.16.14.38.12.65 0a1.62 1.62 0 00.51-.45 2.25 2.25 0 00.29-.58 1.39 1.39 0 01.12-.28.48.48 0 01.17-.2L195 176a.15.15 0 01.2 0 .27.27 0 01.07.25 4.58 4.58 0 01-.13.81 5.77 5.77 0 01-.42 1.2 6.85 6.85 0 01-.82 1.3 4.67 4.67 0 01-1.32 1.12 2.57 2.57 0 01-1.06.36 1.33 1.33 0 01-.86-.22 1.75 1.75 0 01-.59-.79 4.2 4.2 0 01-.24-1.36v-.61-.63a7.37 7.37 0 01.24-1.63 6.84 6.84 0 01.59-1.47 6.06 6.06 0 01.86-1.22 4.71 4.71 0 011.06-.86 2.35 2.35 0 011.32-.41 1.38 1.38 0 01.82.36 1.6 1.6 0 01.42.71 2.52 2.52 0 01.13.66.61.61 0 01-.07.34.71.71 0 01-.2.24l-1.33.76h-.17a.44.44 0 01-.12-.15.5.5 0 00-.29-.25.75.75 0 00-.51.15 1.69 1.69 0 00-.65.72 2.68 2.68 0 00-.29 1.12z"
            style={{
              WebkitTransformOrigin: 192.554,
              MsTransformOrigin: 192.554,
              transformOrigin: 192.554,
            }}
            id="elb8t4920bqkn"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M201.52 175a.74.74 0 01-.08.35.45.45 0 01-.19.23l-1.27.74a.16.16 0 01-.2 0 .38.38 0 01-.08-.26v-3.94a1.6 1.6 0 00-.21-1c-.14-.19-.37-.2-.67 0a1.46 1.46 0 00-.66.78 3.25 3.25 0 00-.21 1.2v3.9a.88.88 0 01-.08.34.61.61 0 01-.2.24l-1.27.73a.14.14 0 01-.19 0 .32.32 0 01-.08-.25v-10.2a.74.74 0 01.08-.35.45.45 0 01.19-.23l1.27-.74a.16.16 0 01.2 0 .37.37 0 01.08.25v3.33a4.31 4.31 0 01.54-.95 2.58 2.58 0 01.84-.78 2.07 2.07 0 01.89-.31.91.91 0 01.69.25 1.75 1.75 0 01.45.85 5.55 5.55 0 01.16 1.49z"
            style={{
              WebkitTransformOrigin: 198.825,
              MsTransformOrigin: 198.825,
              transformOrigin: 198.825,
            }}
            id="elrvpjx25nm1"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M204.5 169.9a.71.71 0 01-.08.34.48.48 0 01-.19.24l-1.28.73a.14.14 0 01-.19 0 .36.36 0 01-.08-.25v-6.72a.81.81 0 01.08-.34.54.54 0 01.19-.24l1.28-.74a.14.14 0 01.19 0 .3.3 0 01.08.25zm0 3.35a.74.74 0 01-.08.35.5.5 0 01-.19.23l-1.28.74a.15.15 0 01-.19 0 .37.37 0 01-.08-.25v-1.58a.81.81 0 01.08-.34.54.54 0 01.19-.24l1.28-.74a.15.15 0 01.19 0 .3.3 0 01.08.25z"
            style={{
              WebkitTransformOrigin: 203.591,
              MsTransformOrigin: 203.591,
              transformOrigin: 203.591,
            }}
            id="el2zpirhwbsnq"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M170.19 209.39a1.3 1.3 0 01-.92-2.21c1.86-1.9 3-4.57 3.54-8.15-6.26-1.28-10-6.71-10-14.59 0-14 11.37-31.89 25.35-40 7.44-4.29 14.53-5.13 19.45-2.29 4.08 2.35 6.32 7.05 6.32 13.22 0 14-11.37 31.88-25.35 40a33.15 33.15 0 01-5.82 2.69c-3.34 7.44-8.49 10.25-12.24 11.29a1.06 1.06 0 01-.33.04zm18.41-64.17c-13.74 7.93-24.92 25.53-24.92 39.22 0 7.72 3.53 12.76 9.68 13.83l.4.07v.4c-.52 4-1.77 6.93-3.84 9a.46.46 0 00.45.76c3.59-1 8.55-3.72 11.76-11l.08-.17.18-.06a33.18 33.18 0 005.84-2.68c13.74-7.94 24.92-25.53 24.92-39.22 0-5.86-2.09-10.29-5.89-12.49-4.65-2.68-11.43-1.84-18.61 2.3z"
            style={{
              WebkitTransformOrigin: 188.37,
              MsTransformOrigin: 188.37,
              transformOrigin: 188.37,
            }}
            id="elwkgg966qze"
            fill="#8AC832"
            className="animable"
          ></path>
        </g>
      </g>
      <g
        id="freepik--character-1--inject-66"
        className="animable"
        style={{
          WebkitTransformOrigin: 348.729,
          MsTransformOrigin: 348.729,
          transformOrigin: 348.729,
        }}
      >
        <g
          id="freepik--character--inject-66"
          className="animable"
          style={{
            WebkitTransformOrigin: 348.729,
            MsTransformOrigin: 348.729,
            transformOrigin: 348.729,
          }}
        >
          <path
            d="M323 396.53a7.81 7.81 0 00-.1 4.11c.39.82 2.85 3.54 7.87 4.52s11.93 0 14.9-.18 12.3 1 15.26 1.36c4.66.63 8.25-.39 10-2.08a3.1 3.1 0 00.7-2.45 12.45 12.45 0 00-.5-3.32z"
            style={{
              WebkitTransformOrigin: 347.167,
              MsTransformOrigin: 347.167,
              transformOrigin: 347.167,
            }}
            id="el29chomyoted"
            fill="#263238"
            className="animable"
          ></path>
          <path
            d="M370.37 393.61c.09.39.17.77.25 1.17a19.54 19.54 0 01.43 6.05c-.6 1.47-2.25 2.28-3.58 2.7-3.5 1.12-6.18.94-10.07.2a71.19 71.19 0 00-11.81-.72c-3.06.2-7.27.79-10.33.51a24.85 24.85 0 01-7.61-1.55c-2-.88-4.13-2-4.62-4.1-.61-4.42 1.25-6.38 3.35-7.61s5.08-1.14 8.27-1.36c2.88-.19 5-.19 7.55-.39a36.67 36.67 0 006.6-.92c1.93-.61 3.92-3.07 4.74-3.16 0 0 12.84-.1 14.07 0 1.41.12 1.85 4.51 2 5.46.14.75.16 1.55.36 2.27.16.48.28.96.4 1.45z"
            style={{
              WebkitTransformOrigin: 347.016,
              MsTransformOrigin: 347.016,
              transformOrigin: 347.016,
            }}
            id="elmpndg5388jb"
            fill="#37474F"
            className="animable"
          ></path>
          <path
            d="M330.79 402.93c-.4-3.19-.93-10.1 4.94-14.09h.75a14.61 14.61 0 00-8.12 0c-4.7 1.25-6.78 5.05-5.61 9.06 0-.04 1.05 3.84 8.04 5.03z"
            style={{
              WebkitTransformOrigin: 329.455,
              MsTransformOrigin: 329.455,
              transformOrigin: 329.455,
            }}
            id="el2lhwlg609ze"
            fill="#FAFAFA"
            className="animable"
          ></path>
          <path
            d="M347.93 387.83c-1.9 1.68-2.56 5.51-2.56 5.51-.24 1.43-2.84 1.64-2.59.26a15 15 0 012.24-5.33 4.4 4.4 0 012.91-.44z"
            style={{
              WebkitTransformOrigin: 345.347,
              MsTransformOrigin: 345.347,
              transformOrigin: 345.347,
            }}
            id="elgf9vfroqfoa"
            fill="#FAFAFA"
            className="animable"
          ></path>
          <path
            d="M342.61 388.48a9.25 9.25 0 00-2.67 5.22c-.26 1.37-2.43 1.35-2.28 0 0 0 .26-3.39 2.28-5a2.89 2.89 0 012.67-.22z"
            style={{
              WebkitTransformOrigin: 340.131,
              MsTransformOrigin: 340.131,
              transformOrigin: 340.131,
            }}
            id="elnyzxtujz1n7"
            fill="#FAFAFA"
            className="animable"
          ></path>
          <path
            d="M376.26 355.59c-.19 2.25-.49 4.28.43 6.76 1.32 3.57 4.12 5.2 5.76 6.6a47.91 47.91 0 014.78 5.51c1.61 2 2 3.14 4.46 5.28a8.73 8.73 0 008.59 1.21c2.1-.89 2.82-1.6 2.69-4.82s-10.37-4.31-10.37-4.31z"
            style={{
              WebkitTransformOrigin: 389.521,
              MsTransformOrigin: 389.521,
              transformOrigin: 389.521,
            }}
            id="el7amsadbrwuo"
            fill="#263238"
            className="animable"
          ></path>
          <path
            d="M401.65 366.55c.87.31 1.09 1.9 1.23 5 .1 2.39 1.15 5.87-2.3 7.37-2.78 1.22-7.23.41-9.11-1.83-2.35-2.81-3.93-5.27-7.28-8.69-2.91-3-5.93-4-7.22-9.9-.83-3.81-.18-5.39 2.52-6.48 3.7-1.5 9.53 3.41 12.44 4.18 2.5.71 8.85 10.03 9.72 10.35z"
            style={{
              WebkitTransformOrigin: 389.87,
              MsTransformOrigin: 389.87,
              transformOrigin: 389.87,
            }}
            id="eldpg43rjl14h"
            fill="#37474F"
            className="animable"
          ></path>
          <path
            d="M391.93 356.24c-.16 0-.33-.1-.5-.16a9.56 9.56 0 00-8 5c-.49 1 1 1.85 1.94 1 2.07-3.91 6.33-4.78 8-5a4.35 4.35 0 00-1.44-.84z"
            style={{
              WebkitTransformOrigin: 388.352,
              MsTransformOrigin: 388.352,
              transformOrigin: 388.352,
            }}
            id="elstqc7edyoas"
            fill="#FAFAFA"
            className="animable"
          ></path>
          <path
            d="M394.32 358a9.45 9.45 0 00-7.46 5c-.49 1 1 1.85 1.94 1a9.73 9.73 0 016.69-4.75c-.4-.41-.79-.84-1.17-1.25z"
            style={{
              WebkitTransformOrigin: 391.127,
              MsTransformOrigin: 391.127,
              transformOrigin: 391.127,
            }}
            id="elke8cw8bvg3"
            fill="#FAFAFA"
            className="animable"
          ></path>
          <path
            d="M378.67 362.93s.29-7.06 10.32-8l.57.31a8.54 8.54 0 00-4.93-3.62c-3.33-.86-6 0-7.72 2.11s.03 7.82 1.76 9.2z"
            style={{
              WebkitTransformOrigin: 382.882,
              MsTransformOrigin: 382.882,
              transformOrigin: 382.882,
            }}
            id="elsy4aeogxxvq"
            fill="#FAFAFA"
            className="animable"
          ></path>
          <path
            d="M405.07 316.62c-1-11-1.07-18.31-1.07-18.31s0-16 .4-31.11c.22-8.4.07-14.1.21-20.74a106 106 0 00-1.75-22s-51.46-10.24-52.1 8.64c-.77 22.63-.68 61.31-1.55 76.09-.49 8.3.35 15.17.87 31.29.43 13.36.3 46.26.3 46.26 5.67 7.78 19.05 1.85 19.05 1.85s4.14-46.18 4.74-55.73c.65-10.26-.43-15.46-.43-15.46l5.31-47.81s.4 15.34.86 23.64 1.14 14.77 3.09 30.19c2 16.15 5.28 45.41 5.28 45.41 6.86 4.08 14.85.81 14.85.81s2.98-41.36 1.94-53.02z"
            style={{
              WebkitTransformOrigin: 377.176,
              MsTransformOrigin: 377.176,
              transformOrigin: 377.176,
            }}
            id="elfgxx4ytt5ro"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M405.07 316.62c-1-11-1.07-18.31-1.07-18.31s0-16 .4-31.11c.22-8.4.07-14.1.21-20.74a106 106 0 00-1.75-22s-51.46-10.24-52.1 8.64c-.77 22.63-.68 61.31-1.55 76.09-.49 8.3.35 15.17.87 31.29.43 13.36.3 46.26.3 46.26 5.67 7.78 19.05 1.85 19.05 1.85s4.14-46.18 4.74-55.73c.65-10.26-.43-15.46-.43-15.46l5.31-47.81s.4 15.34.86 23.64 1.14 14.77 3.09 30.19c2 16.15 5.28 45.41 5.28 45.41 6.86 4.08 14.85.81 14.85.81s2.98-41.36 1.94-53.02z"
            style={{
              WebkitTransformOrigin: 377.176,
              MsTransformOrigin: 377.176,
              transformOrigin: 377.176,
            }}
            id="el2m4j4hynmmq"
            className="animable"
            opacity="0.4"
          ></path>
          <path
            d="M398 250.57s-2.1 7.69-14.85 12.85c0 0-3.46 27.84-3.43 27.26l-.68-21.08 1.16-8.84s11.96-2.53 17.8-10.19z"
            style={{
              WebkitTransformOrigin: 388.52,
              MsTransformOrigin: 388.52,
              transformOrigin: 388.52,
            }}
            id="ela4q8z4z8px"
            className="animable"
            opacity="0.25"
          ></path>
          <path
            d="M397.09 156.81c5.14 0 9.77 1.52 13.87 14.29s7.64 29.47 8 33.6c.44 5.36.16 7.67-4 11.56s-15 13.13-15 13.13l-3.6-15.29 8.34-9.4z"
            style={{
              WebkitTransformOrigin: 407.736,
              MsTransformOrigin: 407.736,
              transformOrigin: 407.736,
            }}
            id="ellxavwabn46"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M397.09 156.81c5.14 0 9.77 1.52 13.87 14.29s7.64 29.47 8 33.6c.44 5.36.16 7.67-4 11.56s-15 13.13-15 13.13l-3.6-15.29 8.34-9.4z"
            style={{
              WebkitTransformOrigin: 407.736,
              MsTransformOrigin: 407.736,
              transformOrigin: 407.736,
            }}
            id="elvmd3thjycl8"
            fill="#FFF"
            className="animable"
            opacity="0.6"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 380.435,
              MsTransformOrigin: 380.435,
              transformOrigin: 380.435,
            }}
            id="elow4tv22vk5"
            fill="#B16668"
            d="M371.15 152.21L373.16 170.02 389.72 166.26 387.58 142.47 371.15 152.21z"
            className="animable"
          ></path>
          <path
            d="M358.7 130.39s-4.42 6.71-3.92 7.36 3.76 1.26 3.76 1.26z"
            style={{
              WebkitTransformOrigin: 356.72,
              MsTransformOrigin: 356.72,
              transformOrigin: 356.72,
            }}
            id="elt8wyllt1wxt"
            fill="#9A4A4D"
            className="animable"
          ></path>
          <path
            d="M360.66 134.35a5 5 0 115-5 5 5 0 01-5 5zm0-8.89a3.89 3.89 0 103.89 3.89 3.9 3.9 0 00-3.89-3.89z"
            style={{
              WebkitTransformOrigin: 360.66,
              MsTransformOrigin: 360.66,
              transformOrigin: 360.66,
            }}
            id="el65y3hqwtja"
            fill="#263238"
            className="animable"
          ></path>
          <path
            d="M371 112.77c-8.5 1.79-11.55 5.19-12.35 18.69-.84 14.11 1.2 18.88 3.05 20.78 1.25 1.29 8.2 1.52 11.71.55 4.39-1.21 14.31-4.73 19-11.82 5.47-8.35 6.9-19.67 1.05-24.31-8.31-6.54-19.04-4.66-22.46-3.89z"
            style={{
              WebkitTransformOrigin: 377.843,
              MsTransformOrigin: 377.843,
              transformOrigin: 377.843,
            }}
            id="elqmw6b8bpeen"
            fill="#B16668"
            className="animable"
          ></path>
          <path
            d="M371.26 153.19l-.4-2.6a16.83 16.83 0 01-8.71 2c1.62.77 5.85 1 9.11.6z"
            style={{
              WebkitTransformOrigin: 366.705,
              MsTransformOrigin: 366.705,
              transformOrigin: 366.705,
            }}
            id="elw16x58pfxwq"
            fill="#9A4A4D"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 364.07,
              MsTransformOrigin: 364.07,
              transformOrigin: 364.07,
            }}
            id="elmbbldzrhtih"
            fill="#263238"
            d="M356.51 128.44L371.63 130.4 371.02 131.46 356.51 129.58 356.51 128.44z"
            className="animable"
          ></path>
          <path
            d="M357.75 118.22a4.21 4.21 0 001.92-.12 3 3 0 001 3.54 4.27 4.27 0 003.81.51 3.71 3.71 0 00-.42 2.63 4.25 4.25 0 004.4 3.17c.09 2 .12 3.91 2.23 4.81 0 0 1.34-5.22 5.74-4.56s5 6.3 2.23 9.73-5.35 2.13-5.39 2.11a9.15 9.15 0 00.7 2.49 10.15 10.15 0 003.72 4.1 20.07 20.07 0 0010.59 2.87c1.38-4 3.65-7 6.05-10.5 1.89-2.74 4.29-5.86 5.24-9.05a17.86 17.86 0 00.11-10.63c-1.05-3.16-2.28-5.56-5.72-6.41-.78-4.23-5-6.46-8.84-8.4a14.22 14.22 0 00-12.44-.1c-1.42-1.5-2.54-3.3-4.51-4.17a4.1 4.1 0 00-4.82.86 6.1 6.1 0 00-.76 4.05 9.49 9.49 0 00-4.85.42 5 5 0 00-3.12 3.53 3.46 3.46 0 002.17 3.92 3 3 0 00-1.1 3.44 2.59 2.59 0 002.06 1.76z"
            style={{
              WebkitTransformOrigin: 377.493,
              MsTransformOrigin: 377.493,
              transformOrigin: 377.493,
            }}
            id="el11wricjtil5n"
            fill="#263238"
            className="animable"
          ></path>
          <path
            d="M370.64 135.73l.15-5.9a3 3 0 10-.15 5.9z"
            style={{
              WebkitTransformOrigin: 368.982,
              MsTransformOrigin: 368.982,
              transformOrigin: 368.982,
            }}
            id="eljnzvwvhsivq"
            fill="#263238"
            className="animable"
          ></path>
          <path
            d="M405.37 164.91c-1.79-4.57-5.66-8.51-11.93-8.7h-4.59c-.71 2.91-11.75 3.85-17 2-2.29.6-13.41 3.5-15.32 4.14-5.46 1.81-5.53 8.77-5.5 24.93 0 15.06 0 32.94-.82 51.79 9.6 5.06 23.54 6.36 34.1 5.29 16.58-1.67 20.57-6.63 20.57-6.63a237.34 237.34 0 01-.6-26.09c.2-7.24 1.73-16.09 2.27-23.92s.5-18.54-1.18-22.81z"
            style={{
              WebkitTransformOrigin: 378.534,
              MsTransformOrigin: 378.534,
              transformOrigin: 378.534,
            }}
            id="el7sa2u8p4s2w"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M405.37 164.91c-1.79-4.57-5.66-8.51-11.93-8.7h-4.59c-.71 2.91-11.75 3.85-17 2-2.29.6-13.41 3.5-15.32 4.14-5.46 1.81-5.53 8.77-5.5 24.93 0 15.06 0 32.94-.82 51.79 9.6 5.06 23.54 6.36 34.1 5.29 16.58-1.67 20.57-6.63 20.57-6.63a237.34 237.34 0 01-.6-26.09c.2-7.24 1.73-16.09 2.27-23.92s.5-18.54-1.18-22.81z"
            style={{
              WebkitTransformOrigin: 378.534,
              MsTransformOrigin: 378.534,
              transformOrigin: 378.534,
            }}
            id="el8nlbrii9au"
            fill="#FFF"
            className="animable"
            opacity="0.3"
          ></path>
          <path
            d="M298.85 141.51c-.93-2.12.13-5.58.53-7.13.66-2.56.27-6.09.43-7.12.39-2.64-1.38-3.17-2.69-1.41-1.19 1.59-1.19 5.07-2.08 5.29s-3.45-6.57-4.79-10.53-1.68-6.49-3.88-6c-1.59.36-1.51 2.41-.73 5.66a34.68 34.68 0 011 4.27c0 .54-.79.62-1.15.74-.68.24-1.85.6-2.2 1.26a5.91 5.91 0 01-.54 1.1c-.58.73-1.77.7-2.39 1.39-.46.5-.5 1.25-.87 1.82-.24.36-.61.63-.84 1a3 3 0 00-.07 2.48 20.79 20.79 0 004.18 7c1.5 1.89 3.86 4.95 4.72 6.3 2.86 4.48 13.41 21.61 18.62 28.35 1.11 1.43 2.1 2.75 4.48 3.39 6 1.6 42.6 4.77 42.6 4.77 10.6.22 14.29-19.1 5.25-20.06 0 0-7.34-.18-16.13-.25-9.4-.09-25.15-.49-25.15-.49s-17.56-20.15-18.3-21.83z"
            style={{
              WebkitTransformOrigin: 320.944,
              MsTransformOrigin: 320.944,
              transformOrigin: 320.944,
            }}
            id="el40dsnzsu71x"
            fill="#B16668"
            className="animable"
          ></path>
          <path
            d="M359 162.44c-5.43-.21-41.23.09-41.23.09l-14.9-15.88a14.52 14.52 0 01-10.8 8.3s6.48 11.82 10.2 17.25c3.42 5 4.24 7.55 9.54 8.58s38.87 4.88 41.78 4.78 7.68-.61 10.7-9.1c2.63-7.46.21-13.8-5.29-14.02z"
            style={{
              WebkitTransformOrigin: 328.713,
              MsTransformOrigin: 328.713,
              transformOrigin: 328.713,
            }}
            id="elarurf8wln5d"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M359 162.44c-5.43-.21-41.23.09-41.23.09l-14.9-15.88a14.52 14.52 0 01-10.8 8.3s6.48 11.82 10.2 17.25c3.42 5 4.24 7.55 9.54 8.58s38.87 4.88 41.78 4.78 7.68-.61 10.7-9.1c2.63-7.46.21-13.8-5.29-14.02z"
            style={{
              WebkitTransformOrigin: 328.713,
              MsTransformOrigin: 328.713,
              transformOrigin: 328.713,
            }}
            id="elrxdfhzzf44p"
            fill="#FFF"
            className="animable"
            opacity="0.6"
          ></path>
        </g>
      </g>
      <defs>
        <filter id="active" height="200%">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="2"
            result="DILATED"
          ></feMorphology>
          <feFlood
            floodColor="#32DFEC"
            floodOpacity="1"
            result="PINK"
          ></feFlood>
          <feComposite
            in="PINK"
            in2="DILATED"
            operator="in"
            result="OUTLINE"
          ></feComposite>
          <feMerge>
            <feMergeNode in="OUTLINE"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
        </filter>
        <filter id="hover" height="200%">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="2"
            result="DILATED"
          ></feMorphology>
          <feFlood floodColor="red" floodOpacity="0.5" result="PINK"></feFlood>
          <feComposite
            in="PINK"
            in2="DILATED"
            operator="in"
            result="OUTLINE"
          ></feComposite>
          <feMerge>
            <feMergeNode in="OUTLINE"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
          <feColorMatrix values="0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"></feColorMatrix>
        </filter>
      </defs>
    </svg>
     );
    }
    
    export default ContactIcon;